import { SRCGeneralConfig, SRCPinCfg, SRCThermostatConfig, SRCThermostatStates } from '@hwcontroller/types';
import { GroupReservation } from '../pages/newReservations/resController';

export enum ReservationInvoicedStatus {
    notPaid = 0,
    fullyPaid = 1,
    partialPayed = 2,
}

export enum GroupInfoStatus {
    active = 1,
    inactive = 0,
}

export enum CashRegPaymentsEnum {
    payIn = 0,
    payOut = 1,
}

export enum ReservationStatus {
    earlyBird = 0,
    confirmed = 1,
    checkedIn = 2,
    canceled = 3,
    closed = 4,
    autoBlocked = 5,
}

export enum ReservationSource {
    walk_in = 1,
    phone = 2,
    email = 3,
    website = 4,
    online_booking = 5,
    travel_agency = 6,
    foreign_travel_agency = 7,
    group_reservation = 8,
    bussiness_trip_company_booking = 9,
    other = 10,
}

export enum TravelPurposeCode
 {
    tourism = 1,
    medical = 2,
    business = 3,
    other = 4,
}

export enum ReservationStatusForCleaning {
    unknown = 0,
    noReservation = 1,
    arrival = 2,
    dueOut = 3,
    stay = 4,
}

export enum InvoiceType {
    geniue = 0,
    advance = 1,
    proforma = 2,
    proformaDispatched = 3,
}

export enum InvoiceReclamationType {
    geniue = 0,
    reclamated = 1,
    storno = 2,
}

export const InvoiceTypeByNum = {
    0: 'geniue',
    1: 'advance',
    2: 'proforma',
    3: 'proformaDispatched',
};

export enum AccommodationTaxPrefix {
    accommodationTax = 'Accommodation tax',
}

export enum HotelUserRole {
    superAdmin = 'superAdmin',
    admin = 'admin',
    condoUser = 'condoUser',
    hwAdmin = 'hwAdmin',
    janitor = 'janitor',
    maid = 'maid',
    managerBussiness = 'managerBussiness',
    managerFull = 'managerFull',
    managerHousehold = 'managerHousehold',
    managerSecurity = 'managerSecurity',
    receptionist = 'receptionist',
    reporting = 'reporting',
    security = 'security',
    posKitchen = 'posKitchen',
    posBartender = 'posBartender',
    posSupervisor = 'posSupervisor',
    offlinePosApi = 'offlinePosApi',
    posOnprem = 'posOnprem',
    hwOnPrem = 'hwOnPrem',
    bmsApi = 'bmsApi',
    documentScanner = 'documentScanner',
}

export interface CustomerModel {
    id?: number;
    documentId?: string | null;
    documentType?: string | null;
    cardNumber?: string | null;
    firstName: string | null;
    lastName: string | null;
    email?: string | null;
    gender?: string | null;
    dateOfBirth?: Date | null;
    birthTown?: string | null;
    birthCountry?: string | null;
    poNumber?: string | null;
    address?: string | null;
    town?: string | null;
    country?: string | null;
    nationality?: string | null;
    phoneOrMobile?: string | null;
    params?: any | null;
    preferredLanguage?: string | null;
    otherLanguage?: string | null;
    companyId?: number | null;
    documentScanId?: number | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    emailHash?: string | null;
    loyaltyProgramId?: number | null;
}

export interface CompanyModel {
    id?: number;
    name: string;
    vatNumber?: string | null;
    idNumber?: string | null;
    address?: string | null;
    poNumber?: string | null;
    town?: string | null;
    country?: string | null;
    notes?: string | null;
    web?: string | null;
    params?: any | null;
    oib?: string | null;
    taxFree?: boolean;
    procurementEmail?: string | null;
    salesEmail?: string | null;
    administrativeEmail?: string | null;
    techSupportEmail?: string | null;
    loyaltyProgramId?: number | null;
    type?: number;
}

export interface RoomInfoModel {
    id?: number;
    uuid?: string | null;
    name: string;
    remoteDeviceId?: string | null;
    roomPhone?: string | null;
    srcProxyId?: number | null;
    tags?: string | null;
    description?: string | null;
    accommodationPriceListId: number | null;
    roomAttributes?: string | null;
    SRCSettings?: any | null;
    availableForRent?: boolean;
    bedCount: number;
    spareBedCount: number | null;
    posItemIds?: string | null;
    params?: string | null;
    cleaningModeActivatedTs?: number | null;
    roomHWDefaults?: any;
    autoPrecomfortMode?: boolean;
    mfcAccessBitMask?: number;
    activeCardCode?: number;
    remoteDeviceId2?: string | null;
    remoteDeviceId3?: string | null;
}

export interface RoomInfoEditModel extends RoomInfoModel {
    id: number;
}

export interface ReservationModel {
    id?: number;
    checkOutTimestamp: number;
    checkInTimestamp: number;
    additionalServicesJson?: any | null;
    statusEnum: ReservationStatus;
    autoBlockCount?: number | null;
    earlyBirdValidTo?: number | null;
    statusChangeNotes?: string | null;
    notes?: string | null;
    adultsNumber: number;
    childrenNumber?: number | null;
    rememberedAccommodationPriceInfo?: PriceOffer[];
    enableSelfCheckIn: boolean | null;
    guest1CodeCopy?: number | null;
    guest2CodeCopy?: number | null;
    guest3CodeCopy?: number | null;
    documents?: string | null;
    receptionistUuid?: string | null;
    //groupReservationStatus - ovo izbrisati
    discountPercentage?: number | null;
    pendingSelfCheckIn?: boolean;
    accommodationPriceListId: number | null;
    tags?: string | null;
    pendingQRSelfCheckIn?: boolean;
    pendingHardwareSelfCheckIn?: boolean;
    groupUuid: string | null;
    roomInfoId: number;
    customerId?: number | null;
    companyId?: number | null;
    invoicedStatus: number;
    createdAt?: Date;
    updatedAt?: Date;
    previousGroupUuid?: string | null;
    providerReservation?: boolean;
    condoUserUuid?: string | null;
    genuineInvoiceIssued?: number;
    openPrice: number | null;
    canceledReservationInvoicingStatus?: number;
    concludedType?: number | null;
    board: string;
    warningNote?: string | null;
    editedByUserUuid?: string | null;
    reservationSource?: number | null;
    channelName?: string | null;
    guestTaxConfig?: GuestTaxConfig | string | null; // Konfiguracija gostiju za children pricing
    onlineReceptionResId?: number | null;
    travelPurposeCode?: number | null;
}

export interface PriceOffer {
    accommodationPriceListId: number | null;
    checkInTimestamp: number;
    checkOutTimestamp: number;
    adultsNumber: number;
    childrenNumber?: number | null;
    priceOfferIntervals: PriceOfferInterval[];
    timestamp?: number;
    openPrice: number | null;
    statusEnum?: number;
    canceledReservationInvoicingStatus?: number;
    id?: number;
    board: string;
    groupUuid?: string | null;
    guestTaxConfig?: GuestTaxConfig | string | null; // Za pamćenje konfiguracije
    totalPrice?: number;
    guestDates?: { id: number; checkIn: number | null; checkOut: number | null }[]; // NOVO
}

export interface PriceListShort {
    pluBase: number | null;
}

export interface PriceOfferInterval {
    from: string;
    to: string;
    fromToDays: number;
    apRules: number[];
    taxPercentage1?: number;
    taxPercentage2?: number;
    taxPercentage3?: number;
    priceList?: any;
    childrenPriceRules?: ChildPriceRule[]; // Pravila za djecu iz cjenika
    boards?: any; // Board cijene
    defaultBoard?: string;
}

export interface PriceOfferIntervalsGroupByReservationId {
    [key: string]: PriceOfferInterval[];
}

export interface ReservationEditModel extends ReservationModel {
    id: number;
}

export interface ReservationWithMfcSql extends ReservationModel {
    mfcAccessBitMask: number;
}
export interface CustomerEditModel extends CustomerModel {
    id: number;
}

export interface CompanyEditModel extends CompanyModel {
    id: number;
}

export interface GroupInfoModel {
    uuid: string;
    note?: string | null;
    discountPercentage?: number | null;
    status: GroupInfoStatus;
    invoicedStatus: ReservationInvoicedStatus;
    receptionistUuid?: string | null;
    checkOutTimestamp: number | null;
    checkInTimestamp: number | null;
    customerId?: number | null;
    companyId?: number | null;
    createdAt?: Date;
    updatedAt?: Date;
    groupName?: string;
    genuineInvoiceIssued?: number;
    type: string;
}

export interface GroupInfoWithReservations extends GroupInfoModel {
    Reservations: ReservationModelWithModelsIncluded[];
}
export interface GroupInfoWithModelsIncluded extends GroupInfoModel {
    Invoices?: InvoiceModelWithInvoiceItems[];
    Customer?: CustomerEditModel;
    Company?: CompanyEditModel;
    Reservations?: ReservationModelWithModelsIncluded[];
}
export interface ReservationGuestReferenceModel {
    id?: number;
    customerId: number;
    reservationId: number;
    documentValidityPeriod?: string | null;
    documents?: string | null;
    isLocked?: boolean;
    note?: string | null;
    placeEntry?: string | null;
    visaEntryDate?: string | null;
    visaTypeAndNumber?: string | null;
    visaValidityPeriod?: string | null;
    applyAccommodationTax?: boolean;
    fixedTaxId?: number;
    fixedTaxId2?: number | null;
    fixedTaxAmount1?: number | null; // NOVO
    fixedTaxAmount2?: number | null; // NOVO
    fixedTaxName1?: string | null; // NOVO
    fixedTaxName2?: string | null; // NOVO
    documentId?: string;
    documentType?: string;
    checkOutTimestamp?: number | null;
    checkInTimestamp?: number | null;
    customerUuid?: string | null;
    paymentCategory?: string | null;
    orderNumber?: number | null;
    fixedTaxType?: 'tax' | 'posItem' | null;
    visaIssuancePlace?: string;
    residencePermitExpiryDate?: string | null;
    visaTypeCode?: string;
    residenceTaxReductionCode?: string | null;
    identityCardIssuer?: string | null;
}

export interface ReservationGuestReferenceEditModel extends ReservationGuestReferenceModel {
    id: number;
}

export interface ReservationGuestReferenceWithModelsIncluded extends ReservationGuestReferenceModel {
    Customer?: CustomerModel;
}

export interface SelfServiceCheckInModel {
    id?: number;
    uuid?: string;
    pinCode: number | null;
    selfCheckInStatus?: string | null;
    selfCheckInValidFrom: number;
    selfCheckInValidTo: number;
    sendSelfCheckInCodeAfterTimestamp: number;
    notificationSent?: boolean;
    notificationIds?: string | null;
    consumptionTime?: number | null;
    issuedRoomCardCode?: number | null;
    gatewayNotificationStatus?: string | null;
    selfCheckInType: string;
    notificationLanguage: string | null;
    reservationId?: number;
}

export interface SelfServiceCheckInModelWithIncludedReservationModel extends SelfServiceCheckInModel {
    Reservation: ReservationModelWithModelsIncluded;
}
//provjerit sta moze bit null i sta ne mora nuzno bit u modelu
export interface DoorAccessPointModel {
    id?: number;
    remoteDeviceId: string;
    srcProxyId: number;
    serialPort: string | null;
    portConfigId: number;
    tags?: string | null;
    name: string;
    description?: string | null;
    whitelistTagCSV?: string | null;
    params?: string | null;
    lastSeenTimestamp: number | null;
    qrCode: string | null;
    messageAfterSuccessfullScan?: string | null;
    documentScannerDeviceReference?: string | null;
    roomTagWhitelistCSV?: string | null;
}

export interface UserInfo {
    uuid: string;
    name: string;
    surname: string;
    email: string;
    role: string;
    enabled: boolean;
    cardNumber: string | null;
    level: number | null;
    oib: string;
    condoRoomInfoIds: any[] | null;
    customerId: number;
    condoUserPersonalDaysPerYear: number;
    settings: any;
    workingHours?: number | null;
    keycloakUuid?: string | null;
    lastLoginTimestamp?: number | null;
}

export interface MinibarLogModel {
    id?: number;
    previousState: number;
    newState: number;
    logType: number;
    parentId?: number | null;
    recordedAt?: number | null;
    roomInfoId?: number | null;
    posItemId: number;
    userUUID?: string | null;
    params?: string | null;
    reservationId?: number | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export interface PosItemModel {
    id?: number;
    barcode?: string | null;
    plu: number;
    type?: string | null;
    subtype?: string | null;
    name: string;
    description?: string | null;
    category?: string | null;
    image?: string | null;
    thumbnail?: string | null;
    enabled?: boolean | null;
    tags?: string | null;
    unitMeasure?: string | null;
    price: number;
    taxId: number;
    tax2Id?: number | null;
    tax3Id?: number | null;
    params?: string | null;
    composites?: string | null;
    flexiblePrice?: boolean | null;
    subcategory?: string | null;
    isComboItem?: boolean;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    preparationRequired: boolean | null;
    normative?: number;
    suplements?: string | null;
    relatedArticlesIds?: number[];
    normativeRetailPriceTotal?: number;
    additionalMargin?: number;
    specialOffer?: boolean;
    specialOfferValidFrom?: number | null;
    specialOfferValidTo?: number | null;
    imageHash?: string | null;
    separateItem?: boolean;
    // showCounterOnInvoice?: boolean;
}

export interface PosItemEditModel extends PosItemModel {
    id: number;
}

export interface SelfCheckInLogModel {
    id?: number;
    timestamp: number;
    reservationId: number | null | undefined;
    description?: string;
    methodName?: string | null;
    methodSuccessfullyPassed?: boolean;
    errorMessage?: string | null;
    params?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export interface NotificationTemplateModel {
    id?: number;
    uniqueName: string;
    type?: string | null;
    title?: string | null;
    body?: string | null;
    isEnabled?: boolean;
    params?: string | null;
    useHtmlTemplate?: boolean;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export interface CleaningStatusHeaderModel {
    id?: number;
    note: string;
    validOnTimestamp: number;
}

export interface CleaningStatusHeaderEditModel extends CleaningStatusHeaderModel {
    id: number;
}

export interface CleaningStatusModel {
    id?: number;
    cleaningStatus: number;
    reservationId: number | null;
    reservationStatus: number;
    cleaningStartedTimestamp: number | null;
    cleaningFinishedTimestamp: number | null;
    cleaningNote: string | null;
    cleanedByUserUuid: string | null;
    cleanedByUserUuid2: string | null;
    cleanedByUserUuid3: string | null;
    user1SrcEncoded: boolean | null;
    user2SrcEncoded: boolean | null;
    user3SrcEncoded: boolean | null;
    cleaningStatusHeaderId: number | null;
    roomInfoId: number | null;
    inspectionStatus: number | null;
    inspectionNote: string | null;
}

export interface CleaningStatusEditModel extends CleaningStatusModel {
    id: number;
}

export interface CleaningStatusExtendedWithIncludedModels extends CleaningStatusModel {
    Maid1: UserInfo | undefined;
    Maid2: UserInfo | undefined;
    Maid3: UserInfo | undefined;
    RoomInfo: RoomInfoEditModel | undefined;
}

export interface CleaningStatusHeaderExtendedWithCleaningStatusModel extends CleaningStatusHeaderEditModel {
    CleaningStatuses: CleaningStatusExtendedWithIncludedModels[];
}

export interface RoleModel {
    key: string;
    value: string | null;
    isActive: boolean;
    params: string | null;
    sessionDurationInMinutes: number | null;
    dashboardRoute: string | null;
    fixedRoute: string | null;
    externalDashboardRoute: string | null;
    externalFixedRoute: string | null;
}

export interface PermissionModel {
    id?: number;
    name: string;
    description: string | null;
    targetId: number | null;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface RoleWithPermissions extends RoleModel {
    Permissions: PermissionModel[];
}

export interface PermissionRoleModel {
    PermissionId: number;
    RoleKey: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface TaxModel {
    id?: number;
    percentageAmount: number | null;
    fixedAmount?: number | null;
    name: string;
    plu?: number | null;
    isActive?: boolean | null;
    params?: string | null;
    isGeneralTax: boolean;
    type?: string | null; // null (default), 'tax', 'services'
    minAge?: number | null; // minimalna dob gosta
    maxAge?: number | null; // maksimalna dob gosta
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export interface AccommodationPricelistModel {
    id?: number;
    parentId: number | null;
    name: string;
    description: string | null;
    tags: string | null;
    pluBase: number | null;
    weight: number;
    infinite: boolean;
    validFrom: number;
    validTo: number;
    blockPromotions: boolean;
    repeatRules: string | null | any;
    accomodationPriceRules: string | number[];
    discountRules: string | null;
    isActive: boolean;
    isDeleted: boolean;
    condoPricelist: boolean;
    params?: string;
    boards: any;
    defaultBoard: string | null;
    webReception: boolean;
    childrenPriceRules?: string | ChildPriceRule[] | null;
    adultPricingConfig?: string | AdultPricingConfig | null; // NOVO V2
}
export interface ChannelManagerMap {
    id?: number;
    provider: string;
    model: string;
    remoteId: string | null;
    remoteUuid: string | null;
    modelId: string | null;
    modelUuid: string | null;
    tags: string | null;
    roomPriceValidTo: number | null;
    remoteName: string | null;
    data: string | null;
    roomInfoIds: number[];
    parentId?: string | null;
    vpType?: number | null;
    vpValue?: number | null;
    modifiedReservationId?: number | null;
    priceOccupancyBased?: number | null;
}

export interface CurrencyModel {
    id?: number;
    shortName: string;
    name: string;
    params?: string;
    isEnabled: boolean;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export interface ReservationWithIncludedModels extends ReservationEditModel {
    RoomInfo: RoomInfoModel;
    Customer: CustomerModel;
    Company: CompanyModel;
}

export interface MinibarLogWithIncludedModels extends MinibarLogModel {
    RoomInfo: RoomInfoModel;
    PosItem: PosItemModel;
    //  InvoiceItem: any; //sad za sad
}

export interface MinibarLogExtended extends MinibarLogModel {
    posItemName: string;
    roomName: string;
}

export interface InitialAndlatestMinibarLogWithIncludedModels {
    filterEnabledPosItemsMinibarLogs: MinibarLogExtended[];
    initialfilterEnabledPosItemsMinibarLogs: MinibarLogExtended[];
}
export interface InvoiceItemsModel {
    id?: number;
    bruttoUnitPrice: number | null;
    bruttoValueWithDiscount: number | null;
    discountPercentage: number | null;
    discountValue: number | null;
    group: string | null;
    invoiceId: number | null;
    itemName: string;
    minibarLogId: number | null;
    nettoUnitPrice: number | null;
    nettoValueWithDiscount: number | null;
    plu: number | null;
    posItemId: number | null;
    quantity: number | null;
    recordedAt: number | null;
    tax1ValueWithDiscount: number | null;
    tax2ValueWithDiscount: number | null;
    tax3ValueWithDiscount: number | null;
    taxIncludedInPrice: boolean;
    taxPercentage1?: number | null;
    taxPercentage2?: number | null;
    taxPercentage3?: number | null;
    totalTaxValue: number | null;
    type: string;
    unitPrice: number | null;
    valueWithDiscount: number | null;
    taxFreeCompany?: boolean;
    subtype?: string | null;
    //Samo za potrebe financijskog izvjesca prodaje - nije u bazi spremljeno
    generalDiscountPercentage?: number | null;
    //Samo za potrebe kalkulacija - nije u bazi spremljeno
    bruttoUnitsValue?: number;
    brutoValueDiscount?: number;
    roomInfoId: number | null;
}

export interface AdvancePaymentsInterface {
    id: number;
    itemName: string;
    invoiceNumber: string;
    paymentAmount: number;
    typeOfPayment: string;
    totalVAT: number;
}

export interface InvoiceModel {
    id?: number;
    advancePayments: AdvancePaymentsInterface[];
    advancePaymentsValue: number | null;
    checkInTimestamp: number;
    checkOutTimestamp: number;
    companyId: number | null;
    companyInfo: string | null;
    connectedInvoiceProcessed: number | null;
    connectedInvoices: number[];
    currency: string;
    currencyExchangeRate: number;
    customerId: number | null;
    customerInfo: string | null;
    defaultCurrency: string;
    deliveredValue: number | null;
    exchangeRates: string | null;
    fiscal: number;
    fiscalId: number | null;
    fiscalSRCProxy: string | null;
    generalDiscountPercentage: number;
    generalDiscountValue: number;
    invoiceNumber: number | null;
    invoiceType: number;
    invoiceValue: number | null;
    issuerCompanyInfo: string | null;
    issuerSecurityCode: string | null;
    locale: string;
    note: string | null;
    operatorName: string | null;
    orderNumber: number | null;
    params: string | null;
    partialPayment: boolean;
    paymentAmount: number | null;
    pendingInvoice: number;
    posTerminalId: number | null;
    posTerminalName: string | null;
    reclamation: number;
    reclamationFiscalId: number | null;
    reclamationReason: string | null;
    refInvoice: number | null;
    groupUuid: string | null;
    reservationId: number | null;
    businessSpaceLabel: string | null;
    sfJIR: string | null;
    tollDeviceLabel: string | null;
    taxIncludedInPrice: boolean;
    taxRecapitulation: string | null;
    terminalType: string;
    timestamp: number | null;
    totalBaseVAT: number | null;
    totalBaseVAT_BD: number | null;
    totalBaseValue: number | null;
    totalBaseValue_BD: number | null;
    totalLineItemDiscountValue: number | null;
    totalVAT: number | null;
    totalValue: number | null;
    typeOfPayment: string | null;
    vatRegistered: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    InvoiceItems?: InvoiceItemsModel[];
    receivedPayment?: number;
    paymentStatus?: number;
    invoiceNumberFull: string | null;
    taxFreeCompany?: boolean;
    operatorUuid: string | null;
    posOrderHeaderIds: number[];
    invoiceConclusionId?: number;
    stockDespatched?: boolean;
    externalInvoiceNumber: number | null;
    stockDocHeaderId: number | null;
    isSyncedWithMaster?: boolean | null;
    advanceTimestamp: number | null;
    invoiceOfflineId?: number | null;
    glPostingStatus: number | null;
    simpleView?: boolean;
}

export interface InvoiceModelWithInvoiceItems extends InvoiceModel {
    InvoiceItems: InvoiceItemsModel[];
}

export interface InvoiceControlerModel {
    invoice: InvoiceModelWithInvoiceItems;
    invoiceItems: InvoiceItemsModel[];
    advanceInvoices: InvoiceModelWithInvoiceItems[];
    proformaInvoices: InvoiceModelWithInvoiceItems[];
    stornoInvoices: InvoiceModelWithInvoiceItems[];
    posTerminalInvoices: InvoiceModelWithInvoiceItems[];
    genuineInvoices: InvoiceModelWithInvoiceItems[];
    checkoutDateMismatchs: number[];
    minibarInvoices: InvoiceModelWithInvoiceItems[];
    availableForAdvancePayment: number;
}

export interface InvoicePreviewObject {
    reservationId: number;
    customerInfo: string;
    companyInfo: string;
    checkInTimestamp: number;
    checkOutTimestamp: number;
    params: string;
}

export interface InvoicePreview {
    invoice: InvoicePreviewObject;
    invoiceItems: InvoiceItemsModel[];
}

export interface InvoiceBaobabModel extends InvoiceControlerModel {
    reservation: ReservationEditModel | null;
    groupReservationsArray: ReservationModelWithModelsIncluded[];
    stayoverOverlap: StayOverOverlap;
    invoicePreview?: InvoicePreview;
    invoiceStornoPreview: InvoiceModelWithInvoiceItems | null;
    accommodationInvoice: InvoiceModelWithInvoiceItems | null;
    loyaltyProgram: any | null;
}

export interface StayOverOverlap {
    overlapReservations: ReservationModelWithModelsIncluded[];
    option: number | null;
    type: string | null;
}

export interface AccommodationOffer {
    invoiceItems: InvoiceItemsModel[];
    priceOfferByLinkedIntervals: PriceOfferInterval[];
}

export interface AccommodationOfferGroup {
    invoiceItems: InvoiceItemsModel[];
    priceOfferByLinkedIntervals: PriceOfferIntervalsGroupByReservationId;
}

export interface PosTerminalModel {
    id?: number;
    name: string;
    isEnabled: boolean;
    terminalType: number;
    fiscalInfo: string | FiscalInfoInterface;
    warehouseId?: number | null;
    params: string;
    tableLayoutIds?: string | null;
    mandatoryTableSelection?: boolean;
    connectedPosTerminals?: string | number[];
    parentPosTerminalId: number | null;
    enableOrderSave?: boolean;
    enableAutoLogout?: boolean;
    uuid?: string | null;
    isOfflinePOSTerminal?: boolean;
    maxMobileTerminals?: number | null;
    cashRegisterMaximum?: number | null;
    includeCardsInCashJournal?: boolean;
}

export enum PosTerminalType {
    checkoutTerminal = 0,
    posInterfaceTerminal = 1,
}

export interface FiscalInfoInterface {
    srcProxyName?: string;
    SRCProxyUUID?: string;
    businessSpace?: string;
    tollDevice?: string;
    printToPos?: boolean;
    charLength?: number;
    printerVendor?: 'config' | 'tring';
    printOperatorName?: boolean;
}

export interface CustomerInfoModel {
    documentId?: string;
    firstName?: string;
    lastName?: string;
    address?: string;
    poNumber?: string;
    town?: string;
    country?: string;
    type?: string;
}

export interface CompanyInfoModel {
    vatNumber?: string;
    oib?: string | null;
    name?: string;
    address?: string;
    poNumber?: string;
    town?: string;
    country?: string;
    type?: string;
    idNumber?: string;
}

export interface FiscalGeneralSettings {
    enableFiscalisation: boolean;
    country: string;
}
export interface RoomInfoMap {
    [key: string]: RoomInfoEditModel;
}
export interface ReservationModelWithModelsIncluded extends ReservationEditModel {
    RoomInfo?: RoomInfoEditModel;
    Customer?: CustomerEditModel;
    Company?: CompanyEditModel;
    GroupInfo?: GroupReservation;
    Invoices?: InvoiceModelWithInvoiceItems[]; // nakon merge ima invoice model
    MinibarLogs?: MinibarLogModel[];
    ReservationGuestReferences?: ReservationGuestReferenceModel[];
    VisaInfo?: ReservationGuestReferenceModel[];
    Guests?: CustomerModel[];
    SelfServiceCheckIn?: SelfServiceCheckInModel;
}

export interface IssuerCompanyInfo {
    name: string;
    hotelName: string;
    address: string;
    postOfficeNumber: string;
    town: string;
    contactEmail: string;
    idNumber: string;
    notes: string;
}

export interface InvoicePresenter {
    invoice: InvoiceModelWithInvoiceItems;
    invoiceItems: InvoiceItemsModel[];
    refInvoice?: InvoiceModelWithInvoiceItems | null;
    invoicePreview?: InvoicePreview;
    groupReservationsArray?: ReservationModelWithModelsIncluded[];
    stornoInvoices?: InvoiceModelWithInvoiceItems[];
    groupInvoiceDetails?: GroupInvoiceDetails;
    translate?: any;
    location?: any;
    print?: boolean;
    padding?: number;
    setInvoiceToSplit?: Function;
}

export interface GroupInvoiceDetails {
    [key: string]: InvoicePreview;
}

export interface TaxRecapitulation {
    base: number;
    taxValue1: number;
    taxValue2: number;
    taxValue3: number;
    totalTaxValue: number;
    taxPercentage1: number | null;
    taxPercentage2: number | null;
    taxPercentage3: number | null;
    taxGroup: string;
}
export interface MessageBrokerInformationModel {
    id?: number;
    channelDriver: string;
    timestamp: number;
    senderInfo: string;
    receiverInfo: string;
    subject: string;
    message: string;
    model?: string;
    modelId?: number;
    statusFlag: number | null;
    notBeforeTimestamp: number | null;
    rules?: string;
    params?: string;
}
export interface MessageBrokerLogModel {
    id?: number;
    request: string;
    response: string;
    timestamp: number;
    remoteReference?: string | null;
    messageBrokerInformationId: number;
}

export interface CalculatedInvoiceLineItem {
    unitPrice: number;
    quantity: number;
    nettoUnitPrice: number;
    bruttoUnitsValue: number;
    brutoValueDiscount: number;
    nettoValueWithDiscount: number;
    valueWithDiscount: number;
    bruttoUnitPrice: number;
    bruttoValueWithDiscount: number;
    tax1ValueWithDiscount: number;
    tax2ValueWithDiscount: number;
    tax3ValueWithDiscount: number;
    totalTaxValue: number;
    discountValue: number;
    discountPercentage: number;
    taxPercentage1: number;
    taxPercentage2: number;
    taxPercentage3: number;
    type?: string | null | undefined;
    itemName?: string | null;
    plu?: number | null;
    posItemId?: number | null;
    subtype?: string | null;
}

export interface GeneralSettingModel {
    uuid: string;
    key: string;
    params: string;
}
export interface ReservationReportHeaderModel {
    id?: number;
    reportNumber: number;
    fromTimestamp: number;
    toTimestamp: number | null;
    userUuid?: string | null;
    date?: string;
}

export interface ReservationReportItemsModel {
    id?: number;
    reservationStatusEnum: number;
    persons: number;
    adults: number;
    children: number;
    days?: number;
    adultDays?: number;
    childDays?: number;
    accommodationTaxValue: number;
    accommodationTaxVAT?: number;
    reservationId: number;
    reservationHeaderId: number;
    warningNote?: string | null; //ovo se samo koristi za upozorenje za rezervacije koje su se trebale checkoutat
}

export interface ReservationReportGuestInfosModel {
    id?: number;
    firstName: string;
    lastName: string;
    gender: string | null;
    birthDate: Date | null;
    birthPlace?: string | null;
    birthCountry?: string | null;
    town?: string | null;
    country?: string | null;
    citizenship: string;
    checkInDate: number;
    checkOutDate: number;
    documentType: string | null; //??
    documentNumber: string | null;
    documentValidityPeriod?: Date | null;
    documentPublisher?: string | null;
    visaType?: string | null;
    visaNumber?: string | null;
    visaValidityPeriod?: Date | null;
    dateEntry?: Date | null;
    placeEntry?: string | null;
    phoneOrMobile?: string | null;
    email?: string | null;
    notes: string | null;
    resReportItemId: number | null;
    customerId: number | null; //ali mora inace bit
    resGuestReferenceId: number;
    foreignServiceUsername?: string | null;
    bookSerialNumber?: string | null;
    accTaxValuePerPeson: number | null;
    paymentCategory?: string | null;
    arrivalOrganisation?: string | null;
    customerUuid?: string | null;
    reservationStatusEnum?: number;
    markAsSend?: boolean;
}

export interface EStranacExportModel {
    //?? valjda je ovako, jer tako dobijem na primjeru exporta
    'Redni broj pod kojim je stranac zaveden u knjigu stranaca': number | string;
    'Serijski broj knjige stranaca u koju je unesen stranac': number | string;
    'Korisničko ime zaposlenog koji je izvršio prijavu stranca': string;
    'Ime stranca': string;
    'Prezime stranca': string;
    'Pol stranca': string;
    'Datum rođenja stranca': string;
    'Država rođenja stranca': string;
    'Mjesto rođenja stranca': string;
    'Državljanstvo stranca': string;
    'Vrsta putne isprave stranca': string;
    'Broj putne isprave stranca': number | string;
    'Rok važenja putne isprave stranca': string;
    'Izdavač putne isprave stranca': string;
    'Vrsta vize stranca': string;
    'Broj vize stranca': string;
    'Rok važenja vize stranca': string;
    'Datum ulaska u državu stranca': string;
    'Mjesto ulaska u državu stranca': string;
    'Broj izdatog fiskalnog računa za stranca': string;
    'Broj telefona stranca': string;
    'Email stranca': string;
    Napomena: string;
    'Datum prijave stranca u smještajnu jedinicu': string;
    'Datum odjave stranca iz smještajne jedinice': string;
    'Korisničko ime zaposlenog koji je izvršio odjavu stranca': string;
    ''?: string;
}

export interface EVisitorCheckOutModel {
    ID: string; // guid, identifikator prijave turista, ako je proslijeđen onda nije potrebno proslijeđivati parametre Facility, DocumentType i DocumentNumber
    Facility: string;
    DocumentType: string;
    DocumentNumber: string;
    CheckOutDate: number | string; // datum odjave turista (format: YYYYMMDD, primjer 20150413)
    CheckOutTime: string; // vrijeme odjave turista (format: hh:mm, primjer 09:42)
}
export interface EVisitorCheckInTouristModel {
    ID: string; //  guid, identifikator prijave turista, ako se proslijedi onda se može upotrebiti za izmjenu ili odjavu određene prijave turista
    Facility: string; //?number šifra objekta u koji se turist prijavljuje. Šifra objekta je objektu dana od sustava e-Visitor.
    StayFrom: number | string; //YYYYMMDD
    TimeStayFrom: string; //?string hh:mm
    ForeseenStayUntil: number | string; //YYYYMMDD
    TimeEstimatedStayUntil: string; //string hh:mm
    DocumentType: string;
    DocumentNumber: string;
    TouristName: string;
    TouristSurname: string;
    Gender: string;
    CountryOfBirth: string; // tro-slovna šifra države (ISO oznaka) rođenja (npr. HRV za Hrvatsku ili DEU za Njemačku)
    CityOfBirth?: string; // ukoliko je država rođenja Hrvatska, onda ovdje treba staviti naziv grada-naselja rođenja u obliku „grad-naselje“ iz pripremljenog šifrarnika, npr. „Zagreb-Adamovec“. Ukoliko država rođenja nije Hrvatska, onda ovdje treba biti upisan naziv grada iz te države s tim da trenutno sustav prihvaća slobodni unos
    DateOfBirth: number | string; // YYYYMMDD
    Citizenship: string; // tro-slovna šifra države (ISO oznaka) čije državljanstvo ima turist (npr. HRV za Hrvatsku ili DEU za Njemačku)
    CountryOfResidence: string; //tro-slovna šifra države (ISO oznaka) prebivališta (npr. HRV za Hrvatsku ili DEU za Njemačku)
    CityOfResidence: string; // ukoliko je država prebivališta Hrvatska, onda ovdje treba staviti naziv grada-naselja prebivališta u obliku „grad-naselje“ iz pripremljenog šifrarnika, npr. „Zagreb-Adamovec“. Ukoliko država prebivališta nije Hrvatska, onda ovdje treba biti upisan naziv grada iz te države s tim da trenutno sustav prihvaća slobodni unos
    ResidenceAddress?: string; // ulica i broj prebivališta
    BorderCrossing?: string; // šifra graničnog prijelaza (obavezno ukoliko je turist iz države koja nije članica EU)
    PassageDate?: number; // datum ulaska u EU (obavezno ukoliko je turist iz države koja nije članica EU)
    TTPaymentCategory: string; // ?number šifra kategorije plaćanja boravišne pristojbe
    ArrivalOrganisation: string; // - šifra (MUP) organizacije dolaska, vrijednost CodeMI iz browse-a ArrivalOrganisationLookup
    TouristAgency?: string; //?number - OIB ili VAT number turističke agencije, ukoliko je organizacija dolaska putem agencije. vrijednost iz browse-a TouristAgencyBrowse. Ukoliko ne postoji tražena agencija možete unijeti novu agenciju u sustav pomoću entity resursa TouristAgency Neobavezan podatak ukoliko ArrivalOrganisation je "Osoban". Ukoliko je "Agencijski" onda je TuristAgency obvezan podatak.
    OfferedServiceType: string; // naziv vrste pružene uslugeEditOfExistingCheckIn – opcionalni podatak. Ukoliko želite izmijeniti postojeću prijavu zbog greške u unosu onda u ovom polju šaljite vrijednost true. Samo aktivna prijava se može izmijeniti, a ključ za identifikaciju postojeće prijave (ukoliko nije proslijeđen ID parametar) su slijedeći podaci: DocumentType, DocumentNumber, DateOfBirth, CountryResidenceID, TouristName. Prilikom izmjene potrebno je slati sve podatke, a ne samo one koje želite izmjeniti.
}

export interface EVistiorExportModel extends EVisitorCheckInTouristModel {
    CheckOutDate: number | string; // datum odjave turista (format: YYYYMMDD, primjer 20150413)
    CheckOutTime: string; // vrijeme odjave turista (format: hh:mm, primjer 09:42)
}

export interface TableModel {
    id?: number;
    backgroundPosition: string | null;
    name: string | null;
    numberOfSeats: number | null;
    tablesLayoutId: number;
    createdAt?: Date;
    updatedAt?: Date;
    pendingTable?: boolean;
    isDeleted?: boolean;
}

export interface TablesLayoutModel {
    id?: number;
    name: string;
    description?: string | null;
    backgroundImage?: string | null;
    walls?: string | null;
    labels?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface PosDisplayConfigModel {
    id?: number;
    name: string;
    associatedUserUuids: string[] | null;
    associatedPrinterUuids: string[] | null;
    associatedTerminalIds: number[] | null;
    posSubscribedTags: string | null;
    type: string | null;
    isKitchen: boolean;
    isTableOrder: boolean;
    isGoodsDispatch?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    associatedPrinterPositions: number[] | null;
}

export interface PosOrderHeaderModel {
    id?: number;
    note?: string | null;
    statusEnum: string;
    startTimestamp: number;
    endTimestamp: number | null;
    tableId: number | null;
    customerId: number | null;
    companyId: number | null;
    invoiceId: number | null;
    createdAt?: Date;
    updatedAt?: Date;
    posTerminalId: number;
    createdByUser: string;
    proformaFiscalId?: string | null; // NOVO
}
export interface AuthTokenInfo {
    token: string;
    user: UserInfo;
}

export interface ChannelManagerRoom {
    id?: number;
    name: string;
    occupancy: number;
    men: number;
    children: number;
    shortname: string;
    subroom: number;
    board: string;
    price: number;
    availability: number;
    woodoo: number;
    rtype: number;
    rtype_name: string;
    boards: string;
    anchorate: number;
    dec_avail: number;
    min_price: number;
    max_price: number;
    priceOccupancyBased?: number | null;
}
export interface DebuggingLogModel {
    id?: number;
    timestamp: number;
    type: string;
    statusType: string | null;
    route: string | null;
    payload: string | null;
    message: string | null;
}

export interface PosTerminalConsumption {
    posItemId: number;
    quantity: number;
    newPrice: number | string; //12.02 Ovo ostavljamo samo na hologicu, na posFrontendu je samo broj
    type: string;
    subtype?: string;
    itemName?: string;
    unitPrice?: number;
    total?: number;
    maxQuantity?: number;
    warehouseId?: number;
    roomInfoId?: number;
    maxTotal?: number;
    discountPercentage: number | null;
    group?: string | null;
}
export interface StockConsumption {
    posItemId: number;
    quantity: number;
    reservationId: number | null;
    roomInfoId: number | null;
    userUuid: string;
    warehouseId?: number;
    maxTotal?: number;
    group?: string | null;
}

export interface BillingSummaryHeader {
    id?: number;
    timestamp: number;
    companyInfo: string;
    note: string;
    defaultCurrency: string;
    currency: string;
    currencyExchangeRate: number;
    typeOfPayment: string;
    invoiceType: number;
    paymentAmount: number;
    exchangeRates: string;
    totalBaseValue_BD: number;
    totalBaseVAT_BD: number;
    totalLineItemDiscountValue: number;
    totalBaseValue: number;
    totalBaseVAT: number;
    generalDiscountPercentage: number;
    generalDiscountValue: number;
    totalValue: number;
    totalVAT: number;
    invoiceValue: number;
    taxIncludedInPrice: boolean;
    taxRecapitulation: string;
    params: string;
    locale: string;
    invoiceNumber: number;
    vatRegistered: boolean;
    paymentStatus: boolean;
    receivedPayment: number;
    invoiceNumberFull: string;
    taxFreeCompany: boolean;
    year: number;
    month: number;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}
export interface StockDocHeaderModel {
    id?: number;
    docNumber: string;
    year?: number;
    sequenceNumber?: number;
    type: number;
    date: number;
    commitedDate: number | null;
    itemsCount: number;
    itemsValue: number;
    createdByUser: string | null;
    commitedByUser: string | null;
    companyId: number | null;
    warehouseId: number | null;
    receivingWarehouseId?: number | null; // za medjuskladisnicu
    locked: boolean;
    currency: string | null;
    invoiceId?: string | null;
    conclusionType?: number | null; //1 manualni, 2 sistemski
    previousConclusion: number | null;
    connectedStockDocHeader?: number | null;
    documentInvoiceNumber?: string | null;
    note?: string | null;
    glPostingStatus: number | null;
    params?: string | null;
    isSyncedWithMaster?: boolean;
    stornoReference?: number | null;
    offlineId?: number | null;
    isDocumentStorno?: boolean;
    retroactiveStockStatus?: number;
    noteReason: string | null;
    deliveryDate?: number | null;
}

export interface StockDocItemModel {
    id?: number;
    skuId: number;
    quantity: number;
    newState?: number;
    purchasePrice: number;
    taxId1: number | null;
    taxId2?: number | null;
    taxId3?: number | null;
    grossMargin?: number; //mora biti al racunam na backendu
    skuPrice: number;
    stockValue?: number | null;
    rebatePercentage?: number | null;
    additionalRebatePercentage?: number | null;
    stockDocHeaderId?: number | null; //mora ga biti al nemam ako tek dodajem header
    skuName: string;
    previousState?: number;
    totalGoodsReceived?: number;
    totalGoodsDespatched?: number;
    totalInovicedStock?: number;
    manualTotalInovicedStock?: number;
    totalCumulativeLoss?: number;
    inventoryRecord?: number;
    lockedItem: boolean;
    invoiceId?: number | null;
    invoiceItemId?: number;
    stockHeaderStockReportId?: number | null;
    priceForOfferNote?: number | null;
    params?: string | null;
    delete?: boolean;
    currentState?: number;
    parentId?: number | null;
    externalCode?: string | null;
    totalProducedState?: number;
    createdAt?: Date;
    updatedAt?: Date;
    purchasePriceNoRebate?: any;
    manualPurchasePrice?: number | null; // decimal - ručno upisana (nova) nabavna cijena kod nivelacije (NULL = nema unosa)
}

export interface StockDocItemModelForStockReport {
    id?: number;
    skuId: number;
    quantity: number;
    newState?: number;
    purchasePrice: number;
    taxId1: number | null;
    taxId2?: number | null;
    taxId3?: number | null;
    grossMargin?: number; //mora biti al racunam na backendu
    skuPrice: number;
    stockValue: number | null;
    stockDocHeaderId: number; //mora ga biti al nemam ako tek dodajem header
    skuName: string;
    previousState: number;
    totalGoodsReceived: number;
    totalGoodsDespatched: number;
    totalInovicedStock: number;
    manualTotalInovicedStock: number;
    totalCumulativeLoss: number;
    inventoryRecord: number;
    lockedItem: boolean;
    invoiceItemId?: number;
    stockHeaderStockReportId?: number | null;
    params?: string | null;
    new?: boolean;
    currentState?: number;
    totalProducedState?: number;
    purchasePriceNoRebate?: any;
}

export interface WarehouseModel {
    id?: number;
    name: string;
    type: number;
    description?: string | null;
    delayInvoiceStockDespatched: boolean;
    getNotificationsForStockState?: boolean;
    isDeleted?: boolean;
}

export interface StockKeepingUnitModel {
    id?: number;
    unitType: number;
    barcode: string | null;
    code: string;
    name: string;
    description?: string;
    // measureCode: string;
    category: string | null;
    taxId1: number | null;
    taxId2?: number | null;
    taxId3?: number | null;
    salesPrice: number;
    grossMarginPercentage: string;
    calculateSalesPriceOnStockIncrease: boolean;
    active: boolean;
    stockMeasureUnit: string;
    purchaseMeasureUnit: string | null;
    purchaseMeasureUnit_stockUnitMultiplier: number | null;
    minimumStock: number;
    replenishStock: number;
    isCounter: boolean;
    cumulativeLoss: number;
    parentId?: number | null;
    params?: string | null;
    isSemiFinished: boolean;
    requiresProduction: boolean;
    avgPurchasePrice: number;
    storageRole: string;
    participatesInRetailPricing: boolean;
}

export interface StockKeepingUnitEditModel extends StockKeepingUnitModel {
    id: number;
}

export interface SkuPLURateModel {
    id?: number;
    skuId: number;
    skuMeasureCode: string;
    pluMeasureCode: string;
    multiplier: number;
    posItemId?: number | null;
    description?: string | null;
    params?: string | null;
    semiFinishedSkuId: number | null;
}
export interface EntryCalculationHeaderModel {
    id?: number;
    docNumber: string;
    year: number;
    sequenceNumber: number;
    date: number;
    commitedDate: number | null;
    newPriceValidFrom: number | null;
    createdByUser: string | null;
    commitedByUser: string | null;
    stockDocHeaderId: number | null;
    companyId: number | null;
    warehouseId: number | null;
    locked: boolean;
    currency: string | null;
    totalTransportation: number;
    totalShipping: number;
    totalCustoms: number;
    totalOtherCosts: number;
    totalInvoicePriceValue: number;
    calculationInvoiceNumber: string | null;
    invoiceId?: string | null;
    glPostingStatus: number | null;
    params?: string | null;
    note?: string | null;
    stornoReference: number | null;
    isDocumentStorno: boolean;
    deliveryDate?: number | null;
}

export interface EntryCalculationItemModel {
    id?: number;
    barcode: string | null;
    code: string;
    name: string;
    quantity: number;
    invoiceUnitPrice: number;
    invoicePriceValue: number;
    rebatePercentage: number;
    netoUnitPrice: number;
    netoPriceValue: number;
    transportation: number;
    shipping: number;
    customs: number;
    otherCosts: number;
    purchaseUnitPrice: number;
    purchasePriceValue: number;
    priceDifferencePercentage: number;
    wholesaleUnitPrice: number;
    wholesalePriceValue: number;
    tax1: number | null;
    tax2: number | null;
    tax3: number | null;
    tax1Total: number | null;
    tax2Total: number | null;
    tax3Total: number | null;
    retailUnitPrice: number;
    retailPriceValue: number;
    entryCalcHeaderId: number | null;
    skuId: number;
    skuPrice: number;
    params?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
    delete?: boolean;
}

export interface StockLogModel {
    id?: number;
    quantity: number;
    dateTime: number;
    warehouseId: number;
    receivingWarehouseId?: number | null;
    skuId: number;
    skuPrice: number;
    invoiceId: number | null;
    invoiceItemId?: number;
    stockDocHeaderId: number | null;
    stockDocHeaderIdForReceiving?: number | null;
    type: number;
    params?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
    roomInfoId?: number | null;
    userCreated: string | null;
    posItemId: number | null;
    multiplier: number;
    skuPluRatesCount: number;
    autoSuggestWriteOff?: boolean;
    reservationId?: number | null;
}

export interface PriceChangeLogHeaderModel {
    id?: number;
    docNumber: string;
    year: number;
    sequenceNumber: number;
    date: number;
    commitedDate: number | null;
    createdByUser: string | null;
    commitedByUser: string | null;
    newPriceValidFrom: number | null; // null je za discount;
    currency: string | null;
    locked: boolean;
    warehouseId: number | null;
    isDocumentStorno: boolean;
    copyDocumentReference: number | null;
    note: string | null;
    type: PriceChangeLogHeaderTypeEnum;
    params?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface PriceChangeLogItemModel {
    id?: number;
    skuId: number;
    skuName: string;
    skuStockCurrent: number;
    previousSkuPrice: number;
    previousSkuPriceValue: number;
    newSkuPrice: number;
    newSkuPriceValue: number;
    taxAdjustment: number;
    priceAdjustment: number;
    priceChangeLogHeaderId: number;
    quantity: number; // za discount
    params?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
    parentId?: number | null;
    delete?: boolean;
}

export interface SKUPurchaseStatisticModel {
    id?: number;
    skuItemId: number;
    warehouseId: number;
    month: number;
    year: number;
    avgPrice: number;
    quantity: number;
    value: number;
    closed: boolean;
    params?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
}

export enum PriceChangeLogHeaderTypeEnum {
    PRICE_CHANGE = 'PRICE_CHANGE',
    DISCOUNT_ADJUSTMENT = 'DISCOUNT_ADJUSTMENT',
}

export enum SKUStatisticPeriodType {
    MONTH = 'MONTH',
    YEAR = 'YEAR',
}

export enum SKUType {
    'beverage' = 1,
    'food' = 2,
    'other' = 3,
}

export const SKUTypeName = {
    1: 'beverage',
    2: 'food',
    3: 'other',
};

export enum SKUStorageRole {
    'BAR' = 'BAR',
    'KITCHEN' = 'KITCHEN',
    'MINIBAR' = 'MINIBAR',
    'OTHER' = 'OTHER',
}

export enum WarehouseType {
    'consignmentWarehouse' = 1,
    'retailWarehouse' = 3,
    'receptionWarehouse' = 5,
}

export enum StockLogType {
    'invoice' = 1,
    'goodsDespatchedInvoice' = 2,
    'householdWriteOff' = 3,
    'goodsDespatchedHousehold' = 4,
    'householdRequiredPermission' = 5,
    'internalGoodsConsumption' = 6,
}

export enum RetroactiveStockStatus {
    NONE = 0,
    PENDING = 1,
    PROCESSING = 2,
    DONE = 3,
    ERROR = 4,
}

export interface EntryCalculationHeaderEditModel extends EntryCalculationHeaderModel {
    id: number;
}

export interface PriceChangeLogHeaderEditModel extends PriceChangeLogHeaderModel {
    id: number;
}

export interface StockDocHeaderEditModel extends StockDocHeaderModel {
    id: number;
}

export interface RetroactiveStockSnapshotModel {
    id: number;
    warehouseId: number;
    snapshotHeaderId: number;
    skuItemId: number;
    skuName?: string;
    chainPosition: number;
    actualPreviousState: number | null;
    actualTotalGoodsReceived: number | null;
    actualTotalGoodsDespatched: number | null;
    actualNewState: number | null;
    retroNetGoodsReceived: number;
    retroNetGoodsDespatched: number;
    correctedPreviousState: number | null;
    correctedCurrentState: number | null;
    correctedNewState: number | null;
    diffQuantity: number | null;
    diffValue: number | null;
    skuPrice: number | null;
    lastUpdated: Date;
}

export interface StockPeriodLockAuditModel {
    id?: number;
    action: 'lock' | 'unlock';
    userUuid: string | null;
    userName: string | null;
    note: string | null;
    createdAt?: Date;
}

export interface StockPeriodLockModel {
    id: number;
    warehouseId: number;
    year: number;
    month: number;
    isLocked: boolean;
    updatedAt?: Date;
    audits?: StockPeriodLockAuditModel[];
}

export interface StockPeriodCloseReadinessModel {
    ready: boolean;
    isPastMonth: boolean;
    blockers: {
        unlockedDocs: number;
        pendingRetro: number;
        openStockReport: boolean;
        earlierPeriodUnlocked: boolean;
    };
}

export interface CorrectedStateResponse {
    snapshotDate: number | null;
    hasPending: boolean;
    items: RetroactiveStockSnapshotModel[];
}

export interface SkuSupplierPriceListPerHeaderModel {
    id?: number;
    validFrom: number;
    companyId: number;
    locked: boolean;
    note?: string;
    params?: string | null;
}

export interface SkuSupplierPriceListItemModel {
    id?: number;
    price: number;
    previousPrice: number | null;
    preferedProcurementSku?: boolean;
    skuId: number;
    headerId: number;
    params?: string | null;
}

export interface SkuItemCodeToSupplierCodeModel {
    id?: number;
    code: string;
    skuId: number;
    companyId: number;
    params?: string | null;
}
export interface WarehouseStock {
    warehouseId: number;
    skuId: number;
    name: string;
    unitType: number;
    storageRole: string;
    isSemiFinished: boolean;
    code: string;
    barcode: string | null;
    isCounter: boolean;
    skuPrice: number;
    stockMeasureUnit: string;
    minimumStock: number;
    replenishStock: number;
    taxId1: number | null;
    taxId2?: number | null;
    taxId3?: number | null;
    cumulativeLoss: number;
    activeItem: boolean;
    previousState: number;
    totalGoodsReceived: number;
    totalGoodsDespatched: number;
    totalInovicedStock: number;
    manualTotalInovicedStock: number;
    totalCumulativeLoss: number;
    //jos ovo za potrebe inventure
    goodsReceiving?: number;
    currentState?: number;
    // stateWithGoodsReceiving?:number;
    newState?: number;
    stockQuantity?: number;
    stockPriceValue?: number;
    stockDocItemId?: number | null;
    inventoryRecord?: number;
    totalWriteOffGoods?: number;
    totalInternalGoodsConsumption?: number;
    averagePurchasePrice?: number;
    notInUseItem?: boolean; //za ostale artikle koje doda na inventuru a nisu se do sad koristili
}

export interface SkuSupplierPriceListPerHeaderEditModel extends SkuSupplierPriceListPerHeaderModel {
    id: number;
}

export interface StockDocItemsExtended extends StockDocItemModel {
    StockKeepingUnit: StockKeepingUnitModel;
    externalCode?: string;
    warehouseId?: number;
}

export interface StockDocItemsExtendedSql extends StockDocItemModel {
    itemId: number;
    name: string;
    unitType: number;
    storageRole: string;
    isSemiFinished: boolean;
    code: string;
    barcode: string | null;
    isCounter: boolean;
    stockMeasureUnit: string;
    minimumStock: number;
    replenishStock: number;
    skuTax1: number | null;
    skuTax2: number | null;
    skuTax3: number | null;
    salesPrice: number;
    parentId: number | null;
    cumulativeLoss: number;
    active: boolean;
    externalCode?: string;
    warehouseId?: number;
}

export interface StockLogsExtendedSql extends StockLogModel {
    itemId: number;
    name: string;
    unitType: number;
    storageRole: string;
    isSemiFinished: boolean;
    code: string;
    barcode: string | null;
    isCounter: boolean;
    stockMeasureUnit: string;
    minimumStock: number;
    replenishStock: number;
    skuTax1: number | null;
    skuTax2: number | null;
    skuTax3: number | null;
    salesPrice: number;
    parentId: number | null;
    cumulativeLoss: number;
    active: boolean;
}

export interface PriceChangeLogHeaderWithItems extends PriceChangeLogsHeadersExtended {
    PriceChangeLogItem?: PriceChangeLogItemsExtended[];
}

export interface PriceChangeLogItemsExtended extends PriceChangeLogItemModel {
    StockKeepingUnit: StockKeepingUnitModel;
}

export interface StockLogsExtended extends StockLogModel {
    StockKeepingUnit: StockKeepingUnitModel;
}

export interface StockDocItemsExtendedWithTaxes extends StockDocItemModel {
    StockKeepingUnit?: StockKeepingUnitModel;
    tax1?: TaxModel;
    tax2?: TaxModel;
    tax3?: TaxModel;
}

export interface StockKeepingUnitExtended extends StockKeepingUnitModel {
    tax1?: TaxModel;
    tax2?: TaxModel;
    tax3?: TaxModel;
}

export interface EntryCalculationItemExtended extends EntryCalculationItemModel {
    StockKeepingUnit: StockKeepingUnitModel;
}

export interface StockDocHeadersExtended extends StockDocHeaderModel {
    Company?: CompanyEditModel | undefined;
    CreatedByUser?: UserInfo | undefined;
    CommitedByUser?: UserInfo | undefined;
}

export interface PriceChangeLogsHeadersExtended extends PriceChangeLogHeaderModel {
    CreatedByUser?: UserInfo | null;
    CommitedByUser?: UserInfo | null;
}

export interface EntryCalcHeaderExtended extends EntryCalculationHeaderModel {
    CreatedByUser1: UserInfo | null;
    CommitedByUser1: UserInfo | null;
    StockDocHeader: StockDocHeaderEditModel | null;
    Company?: CompanyEditModel | null;
    stornoReferenceDocNum?: string | null;
    documentWithStornoRefId?: number | null;
    documentWithStornoRefDocNum?: string | null;
}

export interface StockDocHeadersWithItems extends StockDocHeaderModel {
    StockDocItems: StockDocItemsExtended[];
    Company?: CompanyEditModel | null;
    CreatedByUser?: UserInfo | null; //za template
    CommitedByUser?: UserInfo | null;
    docEntryCalcId: number | null;
    goodsReceivingNote?: number | null;
    goodsDespatchNote?: number | null;
    interWarehouseTransfer?: number | null;
    productionNote?: number | null;
    previousConclusionDocNum?: string | null;
    nextConclusionId?: number | null;
    nextConclusionDocNum?: string | null;
    stornoReferenceDocNum?: string | null;
    documentWithStornoRefId?: number | null;
    documentWithStornoRefDocNum?: string | null;
}

export interface StockDocHeaderAndItems extends StockDocHeaderModel {
    StockDocItems: StockDocItemsExtended[];
}

export interface StockDocHeaderAndItemsSql extends StockDocHeaderModel {
    StockDocItems: StockDocItemsExtendedSql[];
}

export interface StockDocItemsAndHeader extends StockDocItemModel {
    StockDocHeader: StockDocHeaderEditModel;
    StockKeepingUnit: StockKeepingUnitModel;
}

export interface StockDocItemsAndHeaderSql extends StockDocItemModel {
    headerId: number;
    docNumber: string;
    type: number;
    warehouseId: number | null;
    receivingWarehouseId?: number | null;
    itemId: number;
    name: string;
    unitType: number;
    storageRole: string;
    isSemiFinished: boolean;
    code: string;
    barcode: string | null;
    isCounter: boolean;
    stockMeasureUnit: string;
    minimumStock: number;
    replenishStock: number;
    skuTax1: number | null;
    skuTax2: number | null;
    skuTax3: number | null;
    salesPrice: number;
    cumulativeLoss: number;
    active: boolean;
    parentId: number | null;
    noteReason?: string | null;
}

export interface EntryCalcHeadersWithItems extends EntryCalcHeaderExtended {
    EntryCalculationItems: EntryCalculationItemExtended[];
}

export interface SkuPluRateWithItemSql extends SkuPLURateModel {
    id: number;
    name: string;
    salesPrice: number;
}

export interface PosItemWithSkuId extends PosItemEditModel {
    skuId: number;
}

export interface SkuPluRateWithItem extends SkuPLURateModel {
    StockKeepingUnit: StockKeepingUnitModel;
    PosItem?: PosItemModel;
    SemiFinishedSKU?: StockKeepingUnitModel;
    avgPurchasePrice?: number;
}

export interface SkuPluRateSql extends SkuPLURateModel {
    name: string;
    salesPrice: number;
    taxId1: number | null;
    taxId2: number | null;
    taxId3: number | null;
}

export interface SkuPluRateForForm extends SkuPLURateModel {
    StockKeepingUnit: StockKeepingUnitModel | null;
    PosItem?: PosItemModel | null;
    SemiFinishedSKU?: StockKeepingUnitModel | null;
    code: string;
    edit: boolean;
    delete?: boolean;
    normativeRetailPrice?: number;
    additionalMargin?: number;
    avgPurchasePrice: number;
}

export interface SupplierItemsExtended extends SkuSupplierPriceListItemModel {
    StockKeepingUnit: StockKeepingUnitModel;
    externalCode?: string;
}

export interface SupplierPriceListsExtended extends SkuSupplierPriceListPerHeaderModel {
    SkuSupplierPriceListItem: SupplierItemsExtended[];
    Company: CompanyEditModel;
}

export interface SkuItemToSupplierCodeExtended extends SkuItemCodeToSupplierCodeModel {
    StockKeepingUnit: StockKeepingUnitModel;
    externalCode?: string;
    previousPrice?: number;
}

export interface SkuItemSupplierCodeWithCompanyAndSkuItem extends SkuItemCodeToSupplierCodeModel {
    StockKeepingUnit?: StockKeepingUnitModel;
    Company?: CompanyEditModel;
    lastPrice?: number;
}

export interface InventoryWithExistingAndOtherItems {
    existingSkuItems: WarehouseStock[];
    otherSkuItems: WarehouseStock[];
}

export enum StockDocumentTypesEnum {
    goodsReceivingNote = 1, // primitak
    goodsDespatchNote = 2, // otpis
    writeOffGoods = 3, // otpis
    interWarehouseTransfer = 4,
    procurementOrder = 5,
    offerNote = 6,
    invoicedStockNote = 7,
    stockReport = 8,
    productionNote = 9,
    internalGoodsConsumption = 10, // utrošak robe
    correctionNote = 11, // knjižna obavijest
    inventoryAdjustment = 12, // inventurna razlika
    stockLeveling = 13, // nivelacija - usklađivanje šifri artikala
    partialInventoryCount = 14, // vanredni popis - brzi popis manjeg broja artikala
}

export const StockDocument = {
    1: 'goodsReceivingNote',
    2: 'goodsDespatchNote',
    3: 'writeOffGoods',
    4: 'interWarehouseTransfer',
    5: 'procurementOrder',
    6: 'offerNote',
    7: 'invoicedStockNote',
    8: 'stockReport',
    9: 'productionNote',
    10: 'internalGoodsConsumption',
    11: 'correctionNote',
    12: 'inventoryAdjustment',
    13: 'stockLeveling',
    14: 'partialInventoryCount',
};

export enum CorrectionNoteReasons {
    SUPPLIER_RETURN = 'SUPPLIER_RETURN',
    SUPPLIER_ADJUSTMENT = 'SUPPLIER_ADJUSTMENT',
    POS_RETURN = 'POS_RETURN',
    INTERNAL_ADJUSTMENT = 'INTERNAL_ADJUSTMENT',
}

export enum StockReportConclusionType {
    manual = 1,
    system = 2,
}

export const Operations: any = {
    addition: 'addition', // primka
    substraction: 'substraction', // otpremnica
    additionAndSubstraction: 'additionAndSubstraction',
};

export const GoodsRecevingOrDespatch: any = {
    goodsReceivingNote: Operations.addition, // primitak
    goodsDespatchNote: Operations.substraction, // otpis
    writeOffGoods: Operations.substraction, // otpis
    internalGoodsConsumption: Operations.substraction,
    interWarehouseTransfer: Operations.additionAndSubstraction,
    invoicedStockNote: Operations.substraction,
};

export interface SRCProxyModel {
    id?: number;
    SRCProxyUUID: string;
    name: string;
    description: string;
    address: string;
    apiKey: string;
    printerProxy: boolean;
    lastSeenTimestamp: number | null;
    printerLineCharLength: number;
    isSyncedWithMaster?: boolean | null;
    offlineId?: number | null;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface InvoiceConclusionModel {
    id?: number;
    timestamp: number;
    previousInvoiceConclusionId: number | null;
    parentInvoiceConclusionId: number | null;
    operatorUuid: string | null;
    operatorName: string | null;
    shiftManager: string | null;
    note: string | null;
    cashDeposit: number | null;
    cashWithdrawal: number | null;
    fiscalConclusionRef: number | null;
    posTerminalId: number;
    posTerminalName: string | null;
    isPending: number;
    InvoiceConclusionItems?: InvoiceConclusionItemModel[];
    stockDocHeaderId: number | null;
    shiftStart?: number | null;
    shiftEnd?: number | null;
    offlineId?: number | null;
    cashJournalDocNumber?: number | null;
}

export interface CashJournalDPNModel {
    id?: number;
    date: number;
    amount: number;
    docNumber: number;
    year: number;
}

export interface CashJournalEntryModel {
    invoiceConclusionId: number;
    posTerminalName: string;
    cashJournalDocNumber: number | null;
    timestamp: number;
    amount: number;
}

export interface CashJournalDayModel {
    date: string;
    entries: CashJournalEntryModel[];
    dpn: { amount: number; docNumber: number };
    dailyTotal: number;
}

export interface CashJournalReportModel {
    days: CashJournalDayModel[];
    previousBalance: number;
}

export interface InvoiceConclusionModelEditModel extends InvoiceConclusionModel {
    id: number;
}

export interface StockHeaderEnums {
    [key: number]: string;
}

export interface CellsWidth {
    [key: number]: number;
}

export interface HiddenCols {
    [key: string]: string[];
}

export interface UnitOfMeasure {
    [key: string]: string;
}

export interface SheetChange {
    x: number;
    y: number;
    value: string | number | null | boolean;
    skuItem?: StockKeepingUnitModel;
    posItem?: PosItemModel;
    semiFinishedItem?: StockKeepingUnitModel;
    glAccount?: GLAccountModel;
    company?: CompanyEditModel;
    customInput?: boolean;
    customOption?: string | number;
}

export interface SelectOptionAndValue {
    label: string;
    value: string;
    skuId?: number;
    documentInvoiceNumber?: string | null;
    warehouseId?: number | null;
    companyId?: number | null;
    deliveryDate?: number | null;
}

export interface SupplierPriceListToSheet {
    internalSkuCode: string | null;
    internalSkuBarcode: string | null;
    skuItemName: string | null;
    supplierSkuCode: string | null;
    previousPrice: number | null;
    supplierProcurementPrice: number;
    skuId: number | null;
    dataIndex?: number | null;
}

export interface SRCTemplateModel {
    id?: number;
    name: string | null;
    description: string | null;
    SRCSettings: string | null | any; //any moze biti model SRCSettingsModel
}

export interface PosTerminalEditModel extends PosTerminalModel {
    id: number;
}

export interface SmartRoomControllerModel {
    id: number;
    srcProxyId: number;
    remoteDeviceId: string;
    name: string;
    serialPort: string | null;
    portConfigId: number;
    lastSeenTimestamp: number;
    srcType: string;
    sendNotificationAboutFailure: boolean;
    lastTh1Readout: number | null;
    lastTh2Readout: number | null;
    lastTh3Readout: number | null;
    thReadoutTimestamp: number | null;
    lastWire1Readout: number | null;
    lastWire2Readout: number | null;
    lastWire3Readout: number | null;
    wireReadoutTimestamp: number | null;
    SRCIOStates?: number | null;
    firmwareVersion: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export interface SrcCardCodeModel {
    id?: number;
    cardCode: number;
    cardCodeValidTo: number;
    type: string;
    roomInfoId: number;
    statusEnum: number;
    failedAttempts: number;
    lastUpdatedBy: string | null;
    remoteDeviceId: string;
    params?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export interface SrcCardCodeExtendedModel extends SrcCardCodeModel {
    RoomInfo: RoomInfoEditModel;
}

export interface SRCTemplateModel {
    id?: number;
    name: string | null;
    description: string | null;
    SRCSettings: string | null | any; //any moze biti model SRCSettingsModel
}

export interface CardCodeManagementEnums {
    [key: number]: string;
}

export interface InvoiceConclusionItemModel {
    id?: number;
    invoiceType: number;
    cash: number | null;
    card: number | null;
    cheque: number | null;
    virman: number | null;
    proformaDispatched: number | null;
    cashTotal: number | null;
    nonCashTotal: number | null;
    total: number | null;
    totalTaxValue: number | null;
    invoiceCount: number | null;
    stornoInvoiceCount: number | null;
    taxRecapitulation: TaxRecapitulation[];
    invoiceConclusionId: number | null;
    clientType: number | null;
    glPostingStatus: number | null;
}

export interface InvoiceConclusionItemsWithInvoiceConclusionData extends InvoiceConclusionItemModel {
    InvoiceConclusion?: InvoiceConclusionModel;
}

export interface InvoiceConclusionWithItems extends InvoiceConclusionModel {
    InvoiceConclusionItem: InvoiceConclusionItemModel[];
}

export interface PosTerminalPosItemModel {
    id?: number;
    posTerminalId: number;
    posItemId: number;
    description?: string | null;
    price: number;
    topArticle: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    category: string | null;
}
export interface InvoiceItemPosPresenter {
    posItemId: number;
    itemName: string;
    quantity: number;
    unitPrice: number;
    bruttoUnitPrice: number;
    bruttoUnitsValue: number;
}

export interface AttributesModel {
    id?: number;
    name: string;
    description: string | null;
    params: string | null;
    icon: string | null;
}

export interface PersistentNotificationSystemModel {
    id?: number;
    key: string;
    title: string;
    message: string;
    severityEnum: number;
    timestamp: number;
    operatorUuid?: string; // u slučaju da korisnik
    operatorName?: string; // može upravljati notifikacijama
    isActive: boolean;
    targetRoles?: string | string[];
    linkToPage?: string;
    targetUserUuid?: string | null;
    readByUserUuids?: string | string[];
    archivingRoles?: string | string[];
    targetUserName?: string | null;
}

export interface TaskManagementHeaderModel {
    id?: number;
    name: string;
    validFrom: number;
    validTo: number;
    taskHeaderGroup: string;
    roomInfoId: number | null;
    reservationId: number | null;
    notes?: string | null;
    params?: string | null;
}

export interface TaskHistory {
    startTimestamp: number | null;
    endTimestamp: number | null;
}

export interface TaskManagementItemModel {
    id?: number;
    taskContent: string | null;
    taskStatus: number | null;
    startTimestamp?: number | null;
    endTimestamp?: number | null;
    taskGroup: string;
    parentId: number | null;
    userArguments: string | null;
    roomInfoId: number | null;
    reservationId?: number | null;
    reservationIds: string | null;
    customerId: number | null;
    companyId: number | null;
    taskManagementHeaderId: number | null;
    userCreated: string | null;
    userFinished: string | null;
    notes?: string | null;
    params?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
    taskTitle: string | null;
    taskTimeEstimate: number | null;
    userAssigned: string | null;
    totalTaskDuration: number | null;
    inspectionFailedCount?: number;
    userSrcEncoded: number;
    taskHistory: TaskHistory[];
    timestamp: number | null; // datum kreiranja
    roomStatuses: string | null;
    severityEnum: number; //0low,1medium,2high
    // samo za frontend
    subTasks?: TaskManagementItemModel[];
}

export interface TaskManagementHeaderEditModel extends TaskManagementHeaderModel {
    id: number;
}

export interface TaskManagementItemEditModel extends TaskManagementItemModel {
    id: number;
    timestamp: number;
}

export interface TaskManagementHeaderWithTaskItems extends TaskManagementHeaderEditModel {
    TaskManagementItems: TaskManagementItemEditModel[];
}

export enum TaskManagementStatusEnum {
    noStatus = 0,
    pending = 1,
    finished = 2,
    rejected = 3,
}

export enum TaskManagementGroups {
    cleaningStatus = 'cleaningStatus',
    lostAndFound = 'lostAndFound',
    roomRepair = 'roomRepair',
}

export interface GLAccountModel {
    account: string;
    name: string;
    companyId?: number | null;
    companyMandatory: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    showItem?: boolean;
    delete?: boolean;
    editCompanyMandatoryCell?: boolean;
}

export interface LineValue {
    credit: number;
    debt: number;
    balance: number;
    creditBalance: number;
    debtBalance: number;
    openingCredit: number;
    openingDebt: number;
}

export interface GLReportLineModel {
    id?: number;
    parentId: number | null;
    glReportId: number;
    lineName: string;
    lineDisplayOrder: number;
    glAccountsList: string[];
    expression?: string | null;
    columnReference?: string | null;
    numberOfSpecChar?: number | null;
    params?: string | null;
    lineValue?: LineValue;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface GLReportModel {
    id?: number;
    name: string;
    aggregationType: number;
    balanceRule: number | null;
    params?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface GlDocumentModel {
    id?: number;
    docNumber: string;
    module?: string;
    name: string;
    type: number | null;
    class: number | null;
    postingDate: number;
    issueDate: number | null; //zbog frontenda
    dueDate: number | null; //zbog frontenda
    userUuid: string | null; // inace bi morao bit userUuid ali zbog bota ako se nekad dogodi
    isLocked: boolean;
    isDeleted: boolean;
    companyId: number | null;
    externalNumber?: string;
    credit: number;
    debt: number;
    stockDocHeaderId?: number | null;
    entryCalcHeaderId?: number | null;
    invoiceId?: number | null;
    invoiceConclusionId?: number | null;
    note?: string | null;
    params?: string;
    createdAt?: Date;
    updatedAt?: Date;
    User?: UserInfo;
    Company?: CompanyEditModel | null;
    currencyId?: number | null;
    exchangeRate?: number | null;
    isEditAllowed?: boolean;
}

export interface GeneralLedgerModel {
    id?: number;
    glDocumentId: number;
    companyId: number | null;
    account: string;
    credit: number;
    debt: number;
    description: string | null;
    params?: string;
    createdAt?: Date;
    updatedAt?: Date;
    name?: string;
    surname?: string;
    creditForeign?: number;
    debtForeign?: number;
}

export interface GLReportItemModel {
    id?: number;
    openingCredit: number;
    openingDebt: number;
    credit: number;
    debt: number;
    cumulativeCredit: number;
    cumulativeDebt: number;
    creditBalance: number;
    debtBalance: number;
    account: string;
    glReportHeaderId: number;
    params?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface GLReportHeaderModel {
    id?: number;
    reportForMonth: number;
    reportForYear: number;
    glReportId: number;
    isLocked: boolean;
    params?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
    name?: string;
    aggregationType?: number;
    GLReport?: GLReportModel;
}

export interface GeneralLedgerExtended extends GeneralLedgerModel {
    GLAccount?: GLAccountModel;
    Company?: CompanyEditModel | null;
    delete?: boolean;
}

export interface GlDocumentWithItems extends GlDocumentModel {
    GeneralLedger: GeneralLedgerExtended[];
}

export interface GeneralLedgerWithGLDocument extends GeneralLedgerModel {
    GLDocument: GlDocumentModel;
}

export interface GlDocumentWithItemsSql {
    account: string;
    credit: number;
    debt: number;
}

export interface GlReportLineExtended extends GLReportLineModel {
    GLReport?: GLReportModel;
}
export interface GlReportWithLines extends GLReportModel {
    GLReportLines: GLReportLineModel[];
}

export interface GLReportItemExtended extends GLReportItemModel {
    GLAccount: GLAccountModel;
}

export interface GLReportHeaderWithItems extends GLReportHeaderModel {
    GLReportItems?: GLReportItemModel[];
}

export interface GroupedGLReportItemsSql {
    id?: number;
    name?: string;
    account: string;
    credit?: number;
    debt?: number;
    cumulativeCredit?: number;
    cumulativeDebt?: number;
    reportForYear?: number;
    reportForMonth?: number;
}

export interface EntryValueForSelectedPeriod extends GLReportItemModel {
    lastId: number;
    account: string;
}

export interface GlDocumentSql {
    id: number;
    glDocumentId: number;
    name: string | null;
    account: string;
    issueDate: number;
    postingDate: number;
    docNumber: string;
    type: string;
    class: string;
    credit: number;
    debt: number;
    company?: string;
    accountName?: string;
    companyId?: number;
}

export interface GLAutoBookingModel {
    id: number | null;
    documentName: string | null;
    documentItem: string | null;
    itemType: string | null;
    itemSubtype: string | null;
    description: string | null;
    clientType: number | null;
    invoiceType: number | null;
    paymentType: string | null;
    inoCompany: boolean;
    taxFree: boolean;
    glTypeId: number | null;
    glClassId: number | null;
    creditGLAccount: string;
    debtGLAccount: string;
    isBeingUsedFlag: boolean;
    automaticGLBooking: boolean;
    rowIndex?: number;
    params?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export enum GLClientType {
    'customer',
    'company',
}

export interface TypeAndClassModel {
    id?: number;
    type: number;
    name: string;
    shortName: string;
    params?: any;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface LastAutoBookReferences {
    stockDocHeaderId: number | null;
    entryCalcHeaderId: number | null;
    invoiceId: number | null;
    invoiceConclusionId: number | null;
}

export interface GroupedGeneralLedger {
    [key: string]: GeneralLedgerModel;
}

export enum GLReportDocType {
    'closingState' = 1,
    'sum' = 2,
}

export enum TypeAndClassEnum {
    'type' = 1,
    'class' = 2,
}

export const TypeAndClassEnumText: any = {
    1: 'type',
    2: 'class',
};

export const GLReportDocTypeName: any = {
    1: 'closingState',
    2: 'sum',
};

export enum GLAutoBookingDocumentTypes {
    goodsManagement = 1,
    retailPriceCalculation = 2,
    invoices = 3,
    invoiceConclusion = 4,
}

export enum GLAutoBookingDocumentTypeNames {
    goodsReceivingNote = 'goodsManagement',
    goodsDespatchNote = 'goodsManagement',
    writeOffGoods = 'goodsManagement',
    internalGoodsConsumption = 'goodsManagement',
    correctionNote = 'correctionNote',
    inventoryAdjustment = 'inventoryAdjustment',
    interWarehouseTransfer = 'goodsManagement',
    procurementOrder = 'goodsManagement',
    offerNote = 'goodsManagement',
    invoicedStockNote = 'goodsManagement',
    stockReport = 'goodsManagement',
    retailPriceCalculation = 'retailPriceCalculation',
    regularInvoice = 'invoices',
    advanceInvoice = 'invoices',
    proformaInvoice = 'invoices',
    proformaDispatchedInvoice = 'invoices',
    invoiceConclusion = 'invoiceConclusion',
}

export enum GLAutoBookingGoodsManagement {
    goodsReceivingNote = 1,
    goodsDespatchNote = 2,
    writeOffGoods = 3,
    // interWarehouseTransfer = 4,
    procurementOrder = 5,
    offerNote = 6,
    stockReport = 8,
    internalGoodsConsumption = 10,
    correctionNote = 11,
    inventoryAdjustment = 12,
    // stockLeveling = 13,
}

export enum GLAutoBookingRetailCalculation {
    retailPriceCalculation = 'retailPriceCalculation',
}

export enum GLAutoBookingInvoices {
    geniue = 'regularInvoice',
    advance = 'advanceInvoice',
    proforma = 'proformaInvoice',
    proformaDispatched = 'proformaDispatchedInvoice',
}

export enum InvoiceTypeOfPayment {
    'Cash' = 'G',
    'Card' = 'K',
    'Cheque' = 'C',
    'Virman' = 'V',
    'Virman2' = 'T',
}

export enum TypeOfPaymentEnums {
    'G' = 'Cash',
    'K' = 'Card',
    'C' = 'Cheque',
    'V' = 'Virman',
    'T' = 'Virman',
}

export enum GLAutoBookingInvoiceConclusion {
    invoiceConclusion = 'invoiceConclusion',
}

export enum GLAutoBookingGoodsManagementValues {
    grossValue = 'grossValue',
    baseValue = 'baseValue',
    totalTaxValue = 'totalTaxValue',
    tax1Value = 'tax1Value',
    tax2Value = 'tax2Value',
    tax3Value = 'tax3Value',
    rebateValue = 'rebateValue',
}

export enum GLAutoBookingRetailCalculationValues {
    invoicePriceValue = 'invoicePriceValue',
    rebateValue = 'rebateValue',
    netoPriceValue = 'netoPriceValue',
    transportationValue = 'transportationValue',
    shippingValue = 'shippingValue',
    customsValue = 'customsValue',
    otherCostsValue = 'otherCostsValue',
    allDependetCosts = 'allDependetCosts',
    purchasePriceValue = 'purchasePriceValue',
    wholesalePriceValue = 'wholesalePriceValue',
    totalTaxValue = 'totalTaxValue',
    retailPriceValue = 'retailPriceValue',
}

export enum GLAutoBookingInvoiceValues {
    grossValue = 'grossValue',
    baseValue = 'baseValue',
    grossValueWithDiscount = 'grossValueWithDiscount',
    baseValueWithDiscount = 'baseValueWithDiscount',
    totalTaxValue = 'totalTaxValue',
    tax1Value = 'tax1Value',
    tax2Value = 'tax2Value',
    tax3Value = 'tax3Value',
    accommodationTaxValue = 'accommodationTaxValue',
    discountValue = 'discountValue',
}

export enum GLAutoBookingInvoiceConclusionValues {
    grossValue = 'grossValue',
    grossValueWithDiscount = 'grossValueWithDiscount',
    totalTaxValue = 'totalTaxValue',
    cashValue = 'cashValue',
    cardValue = 'cardValue',
    chequeValue = 'chequeValue',
    virmanValue = 'virmanValue',
}

export enum GLAutoBookingDocumentNames {
    goodsReceivingNote = 'goodsReceivingNote',
    goodsDespatchNote = 'goodsDespatchNote',
    writeOffGoods = 'writeOffGoods',
    internalGoodsConsumption = 'internalGoodsConsumption',
    correctionNote = 'correctionNote',
    inventoryAdjustment = 'inventoryAdjustment',
    interWarehouseTransfer = 'interWarehouseTransfer',
    productionNote = 'productionNote',
    stockLeveling = 'stockLeveling',
    procurementOrder = 'procurementOrder',
    offerNote = 'offerNote',
    invoicedStockNote = 'invoicedStockNote',
    stockReport = 'stockReport',
    retailPriceCalculation = 'retailPriceCalculation',
    regularInvoice = 'regularInvoice',
    advanceInvoice = 'advanceInvoice',
    proformaInvoice = 'proformaInvoice',
    proformaDispatchedInvoice = 'proformaDispatchedInvoice',
    invoiceConclusion = 'invoiceConclusion',
}

export enum AutoGLBookingValues {
    grossValue = 'grossValue',
    baseValue = 'baseValue',
    grossValueWithDiscount = 'grossValueWithDiscount',
    baseValueWithDiscount = 'baseValueWithDiscount',
    totalTaxValue = 'totalTaxValue',
    tax1Value = 'tax1Value',
    tax2Value = 'tax2Value',
    tax3Value = 'tax3Value',
    rebateValue = 'rebateValue',
    invoicePriceValue = 'invoicePriceValue',
    netoPriceValue = 'netoPriceValue',
    transportationValue = 'transportationValue',
    shippingValue = 'shippingValue',
    customsValue = 'customsValue',
    otherCostsValue = 'otherCostsValue',
    allDependetCosts = 'allDependetCosts',
    purchasePriceValue = 'purchasePriceValue',
    wholesalePriceValue = 'wholesalePriceValue',
    retailPriceValue = 'retailPriceValue',
    accommodationTaxValue = 'accommodationTaxValue',
    discountValue = 'discountValue',
    cashValue = 'cashValue',
    cardValue = 'cardValue',
    chequeValue = 'chequeValue',
    virmanValue = 'virmanValue',
}

export interface AutoBookingRule {
    documentItem: string[];
    clientType: number[] | null;
    itemType: (documentName: string, documentItem: string) => string[];
    itemSubtype: (documentName: string, itemType?: string) => string[];
    invoiceType: number[] | null;
    paymentType: (documentName: string, documentItem?: string) => string[];
    glTypeId: TypeAndClassModel[];
    glClassId: TypeAndClassModel[];
    creditGLAccount: GLAccountModel[];
    debtGLAccount: GLAccountModel[];
}

export enum GLAutoBookingItemTypes {
    all = 'all',
    posTerminal = 'posTerminal',
    accommodation = 'accommodation',
    services = 'services',
    tax = 'tax',
    insurance = 'insurance',
    minibar = 'minibar',
    avans = 'avans',
    avansProcessed = 'avansProcessed',
}

export enum GLAutoBookingItemTypesTranslate {
    all = 'All invoice items',
    posTerminal = 'Goods',
    accommodation = 'Accommodation',
    services = 'Services',
    tax = 'Accommodation tax',
    insurance = 'Insurance',
    minibar = 'Minibar',
    avans = 'Advance',
    avansProcessed = 'Processed advance invoices',
}

export interface GLAutoBookingTotalInvoiceItemsValuesByType {
    baseValue: number;
    grossValue: number;
    baseValueWithDiscount: number;
    grossValueWithDiscount: number;
    taxValue: number;
    tax1Value: number;
    tax2Value: number;
    tax3Value: number;
    accommodationTaxValue: number;
    discountValue: number;
    rebateValue: number;
    cashValue: number;
    cardValue: number;
    chequeValue: number;
    virmanValue: number;
}

export interface GLAutoBookingTotalInvoiceConcsludionDetilValuesByType {
    grossValue: number;
    grossValueWithDiscount: number;
    taxValue: number;
    discountValue: number;
    cashValue: number;
    cardValue: number;
    chequeValue: number;
    virmanValue: number;
}

export enum PosItemSubTypesTranslate {
    beverage = 'beverage',
    food = 'food',
    null = 'other',
}

export enum AllPosItemSubTypes {
    beverage = 'Beverage',
    food = 'Food',
    'null' = 'Other',
}

export interface AutoBookingRulesInterface {
    [key: string]: AutoBookingRule;
}

export enum BalanceRuleType {
    'Not selected' = 0,
    'creditMinusDebt' = 1,
    'debtMinutCredit' = 2,
}

export const BalanceRuleName: any = {
    0: '',
    1: 'creditMinusDebt',
    2: 'debtMinutCredit',
};

export interface PricesAndRestrictions {
    closed: number;
    closed_arrival: number;
    closed_departure: number;
    min_stay: number;
    max_stay: number;
    min_stay_arrival: number;
    id_rplan: number;
    id_room: number;
    day: number;
    date: string;
    price: number;
    avail: number;
}

export interface RestrictionsGroupedByRoomRemoteId {
    [key: string]: PricesAndRestrictions[];
}

export interface InvoiceConclusionDetailsModel {
    id?: number;
    plu: number | null;
    name: string | null;
    pluPrice: number | null;
    quantity: number;
    type: string | null;
    subtype: string | null;
    totalValueWithDiscount: number;
    totalValue: number;
    taxTotal: number;
    skuTotal: number;
    dailyPriceAdjustments: number;
    normativeRecapitulations: NormativeRecapitulation[];
    invoiceConclusionId: number | null;
    invoiceType: number;
    group: string;
    posTerminalName: string;
    posTerminalId: number;
    tags?: string | null;
}

export interface NormativeRecapitulation {
    id: number;
    name: string;
    quantity: number;
    multiplier: number;
    skuPrice: number;
    totalValue: number;
}

export enum InvoiceConclusionIsPendingEnum {
    concluded = 0,
    pending = 1,
    activePending = 2,
}

export interface PaymentTotals {
    cash: number;
    card: number;
    virman: number;
    total: number;
}

export interface InvoiceConclusionDetailsResult {
    invoiced: InvoiceConclusionDetailsModel[];
    proformaDispatched: InvoiceConclusionDetailsModel[];
    paymentTotals?: PaymentTotals;
    paymentTotalsByType?: { [key: string]: PaymentTotals };
}

export interface InvoiceConclusionDetailsByPosTerminalId {
    [key: string]: InvoiceConclusionDetailsResult;
}
export interface BlobDocumentModel {
    uuid?: string;
    name: string | null;
    type: string | null;
    category: string | null;
    size: number | null;
    data: any;
}

export interface ValueLabelString {
    value: string;
    label: string;
}

export interface StockLogsWithPosItem extends StockLogModel {
    itemName: string;
    itemPrice: number;
}

export interface ReservationModelForDocScann extends ReservationEditModel {
    Customer: CustomerEditModel | null;
    Company: CompanyEditModel | null;
    RoomInfo: RoomInfoEditModel;
    customers: CustomerEditModel[];
    reservationGuestReferences: ReservationGuestReferenceEditModel[];
}

export interface PaginatedData {
    data: any[];
    dataCount: number;
    totals?: any;
}

export interface DocumentScannerDeviceModel {
    name: string;
    description: string | null;
    uuid: string | null; //zbog kreiranja
}
export interface ReservationGuestBoard {
    id?: number;
    timestamp: number | null;
    reservationId: number | null;
    roomInfoId: number | null;
    checkInTimestamp: number | null;
    checkOutTimestamp: number | null;
    customerId: number | null;
    firstName: string | null;
    lastName: string | null;
    reservationGuestReferenceId: number | null;
    type: string | null;
    board: string | null;
    posTerminalId?: number;
    roomName?: string; // LEFT JOIN
}
export interface PaginatedDataGLDoc {
    data: GlDocumentSql[];
    dataCount: number;
}

export interface LastCleaningForRooms {
    roomInfoId: number;
    endTimestamp: number;
    taskStatus: number;
}

export interface WhiteListModel {
    id?: number;
    name: string;
    tags: string;
    description?: string | null;
    params?: string | null;
    mfcAccessBitMask: number | null;
    createdAt?: number;
    updatedAt?: number;
}

export interface WhiteListItemWithWhiteList extends WhiteListItemModel {
    WhiteList: WhiteListModel;
}

export interface WhiteListItemModel {
    id?: number;
    name: string;
    code: string;
    description?: string | null;
    params?: string | null;
    enabled: boolean;
    whiteListId: number;
    validToTimestamp: number;
    createdAt?: number;
    updatedAt?: number;
}

export interface HouseholdRefillSetupModel {
    id?: number;
    skuId?: number;
    posItemId: number | null;
    quantity: number;
    roomType: number;
    reservationStatus: string | null;
    guestsNumber: number | null;
    warehouseId: number | null;
    type: number;
}

export interface WarehouseItemModel {
    id?: number;
    posItemId: number | null;
    skuId: number | null;
    type: number;
    warehouseId: number | null;
    autoSuggestWriteOff: boolean;
    laundryDispatched: boolean;
    skuPluRates: string | SkuPLURateModel[];
    posItemName?: string; // Left join
}

export interface AgregatedWatehousePosItems extends HouseholdRefillSetupModel {
    autoSuggestWriteOff: boolean;
    laundryDispatched: boolean;
    type: number;
}
export enum ClientTypeEnum {
    companyType = 1,
    customerType = 2,
}

export const ClientTypeEnumByNum = {
    1: 'companyType',
    2: 'customerType',
};
export interface SkuPLURateModelExtended extends SkuPLURateModel {
    name: string;
}

export interface RoomEventTicketModel {
    id?: number;
    category: string | null;
    ruleName: string;
    openingTimestamp: number;
    closingTimestamp: number | null;
    notes?: string | null;
    openingRoomIOChangesRawId?: number | null;
    closingRoomIOChangesRawId?: number | null;
    openingRoomEventRawId?: number | null;
    closingRoomEventRawId?: number | null;
    roomInfoId: number;
    reservationId?: number | null;
    customerId?: number | null;
    remoteDeviceId: string;
}

export interface RoomCardCodeModel {
    id?: number;
    cardCode: number;
    cardCodeValidTo: number;
    type: string;
    params?: string;
    roomInfoId: number;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface TableLayoutWithTable extends TablesLayoutModel {
    Table: TableModel;
}

export interface ResGuestRefWithCustomerSql extends ReservationGuestReferenceEditModel {
    firstName: string;
    lastName: string;
    gender: string;
    dateOfBirth: Date | null;
    birthTown: string | null;
    phoneOrMobile: number | null;
    email: string | null;
    nationality: string | null;
    country: string | null;
    birthCountry: string | null;
    town: string | null;
    warningNote?: string | null;
    resCheckInTimestamp: number;
    resCheckOutTimestamp: number;
    guestCheckedIn?: boolean;
    resGuestRefId: number;
}

export const predefinedGLTypeAndClasses = {
    inboundDocument: 'inboundDocument',
    outboundDocument: 'outboundDocument',
    internalDocument: 'internalDocument',
    financialVoucher: 'financialVoucher',
    otherDocuments: 'otherDocuments',
    bankStatements: 'bankStatements',
    cashRegister: 'cashRegister',
    foreignCurrencyDocuments: 'foreignCurrencyDocuments',
    incomingAccounts: 'incomingAccounts',
    outgoingAccounts: 'outgoingAccounts',
};

export interface LoyaltyProgramModel {
    id?: number;
    name: string;
    accomodationDiscount: number;
    foodDiscount: number;
    beverageDiscount: number;
    servicesDiscount: number;
    otherServicesDiscount: number;
    minPointsToActivate: number | null;
    isActive: boolean;
}

export interface InvoiceModelWithSequelize extends InvoiceModelWithInvoiceItems {
    save: () => Promise<void>;
    update: (values: Partial<InvoiceModelWithInvoiceItems>) => Promise<void>;
    dataValues?: InvoiceModelWithInvoiceItems;
    // Add other Sequelize methods as needed
}
export interface StockCardInterface {
    skuId: number;
    posItemId?: number;
    date: number;
    inboundQty: number;
    outboundQty: number;
    price: number;
    inboundPrice: number;
    outboundPrice: number;
    docNumber: string | null;
    docId: number | null;
    invoiceId: number | null;
    invoiceNumberFull?: string | null;
    type: string | null; //kalkulacija ili nista
}

export enum NumberDecimalSeparator {
    dot = 'en-US',
    cooma = 'de-DE',
}

export enum PosItemSubTypes {
    beverage = 'Beverage',
    food = 'Food',
    null = 'Other',
}

export enum CompaniesTypes {
    client = 1,
    supplier = 2,
    clientAndSupplier = 3,
}

export interface RoomModuleMapModel {
    id?: number;
    roomInfoId: number | null; //zbog brisanja
    bmsNodeHWModuleId: number | null; //zbog brisanja
    priority: number;
    params?: string;
    createdAt?: Date;
    updatedAt?: Date;
    deleteRow?: boolean;
}

export interface BMSNodeModel {
    id?: number;
    BMSNodeUUID: string;
    name: string;
    description: string;
    address: string;
    apiKey: string;
    lastSeenTimestamp: number;
    createdAt?: Date;
    updatedAt?: Date;
    apiKeyUuid?: string;
}

export interface BMSNodeHWModuleModel {
    id?: number;
    BMSNodeUUID: string;
    hwModuleUUID: string;
    name: string;
    label: string;
    dbDevices: string[];
    connected: boolean;
    address: string[];
    type: string;
    params?: any;
    isLocked: boolean;
    style?: any;
    states?: any;
    busId: string;
    channel: number;
    uuidGateway: string;
    lastSeenTimestamp: number;
    BMSSettings?: any;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface BMSNodeIODeviceModel {
    id?: number;
    BMSNodeUUID: string;
    deviceUUID: string;
    name: string;
    label?: string;
    triggerType: string;
    hwPin: number;
    type: string;
    params?: any;
    isLocked: boolean;
    connected: boolean;
    isPartOfComposite: boolean;
    intendedValue: number;
    style?: any;
    states?: any;
    hwModuleUUID: string;
    tags?: string;
    createdAt?: Date;
    updatedAt?: Date;
}
export interface BMSNodeItemModel {
    id?: number;
    BMSNodeUUID: string;
    scenes?: string[];
    groups?: string[];
    groupItems?: string[];
    createdAt?: Date;
    updatedAt?: Date;
}

export interface BMSNodeItemModel {
    id?: number;
    BMSNodeUUID: string;
    scenes?: string[];
    groups?: string[];
    groupItems?: string[];
    createdAt?: Date;
    updatedAt?: Date;
}

export interface BMSHWSettings {
    accessCodes: any[];
    generalSettings: SRCGeneralConfig;
    ioConfig: SRCPinCfg[];
    roomTime: number;
    termValues: SRCThermostatConfig[];
    termStates: SRCThermostatStates[];
    externalThermostatConnection?: any;
    thermostatSensor?: any;
}

export interface BMSSrcCardCodeModel {
    id?: number;
    cardCode: number;
    cardCodeValidFrom: number;
    cardCodeValidTo: number;
    type: string;
    roomInfoId?: number;
    reservationId?: number | null;
    taskManagementHeaderId?: number | null;
    statusEnum?: number;
    failedAttempts?: number;
    lastUpdatedBy?: string | null;
    params?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}
export interface ReservationAnalyticsData {
    occupanyRate: number;
    adr: number;
    totalAccommodationRevenue: number;
    perviousOccupanyRate?: number;
    previousAdr?: number;
    previousTotalAccommodationRevenue?: number;
}

export interface ShortAnaltyticsData {
    occupanyRate: number;
    adr: number;
    totalAccommodationRevenue: number;
    totalFAndBRevenue: number;
    totalAccommodationTaxRevenue: number;
    totalDiscount: number;
    netoRevenue: number;
    cogs: number;
    brutoMargin1: number;
    totalOtherCosts: number;
    brutoMargin2: number;
}

export interface DetailedAnalyticsData {
    revenueData: RevenueDataInterface;
    costsData: CostsDataInterface;
    profitData: ProfitDataInterface;
    occupanyData: OccupancyDataInterface;
    efficiencyData: EfficiencyDataInterface;
    satisfactionData: SatisfactionDataInterface;
}
export interface RevenueDataInterface {
    totalRevenue: number;
    totalRevenuePerAvailableRoom: number;
    roomRevenuePerAvailableRoom: number;
    fAndbRevenuePerAvailableSeat: number;
    ancillaryRevenuePerGuest: number;
}
export interface CostsDataInterface {
    labourCostPercentage: number;
    labourCostPerAvailableRoom: number;
    utilityCostPercentage: number;
    fAndCostOfGoodsSold: number;
}
export interface ProfitDataInterface {
    grossOperatingProfit: number;
    grossOperatingProfitPerAvailableRoom: number;
    netoOperatingIncome: number;
    profitMargin: number;
}
export interface OccupancyDataInterface {
    occupanyRate: number;
    marketPenatrationIndex: number;
    averageLengthOfStay: number;
}
export interface EfficiencyDataInterface {
    departmentalProfitMargin: number;
    revenueGenerationIndex: number;
}
export interface SatisfactionDataInterface {
    guestSatisfactionIndex: number;
    complaintResolutionRate: number;
}

export interface ChannelManagerPlan {
    id?: number;
    name: string;
    daily: number;
}

export interface ChannelManagerVirtualPlan {
    id?: number;
    name: string;
    type: number;
    value: string;
    realPlanId: number;
}

export interface SalesStatisticReservationModel {
    id?: number;
    month: number;
    year: number;
    roomInfoId: number;
    totalNights: number;
    totalNightsOTA: number;
    totalRevenue: number;
    totalRevenueFromGroupRes: number;
    totalAvans: number;
    totalAvansAndRevenue: number;
}

export interface SalesStatisticInvoiceModel {
    id?: number;
    month: number;
    year: number;
    posTerminalId: number;
    totalAccommodationRevenue: number;
    totalAccommodationTaxRevenue: number;
    totalMinibarRevenue: number;
    totalFBRevenue: number;
    totalServices: number;
    totalOtherRevenue: number;
    totalDiscount: number;
    totalRevenue: number;
    totalAvans: number;
    totalAvansProcessed: number;
    invoiceConclusionId: number | null;
}

export interface ReservationsPerformanceForecastModel {
    id?: number;
    month: number;
    year: number;
    version: string;
    totalNights: number;
    totalNightsCinCou: number;
    totalRevenue: number;
    totalRevenueInvoice: number;
}

export interface OtherSettingsModel {
    checkInTime: string;
    checkOutTime: string;
    relayServer: string;
    enableHouseholdAutoGeneration: boolean;
    sendReservationConfirmationToGuest: boolean;
    householdAutogenerationTime: string;
    invalidateEarlyBirdsHoursBeforeCheckIn: number;
    invalidateConfirmedReservationsHoursAfterPlannedCheckIn: number;
    moveInvalidatedConfirmedReservationToStatusEnum: number;
    dailyCleaningStartHour: number;
    dailyCleaningEndHour: number;
    QRCodeValidTimeAfterFirstConsumption: number;
    numberOfDaysForEncriptingGuests: number;
    householdScheduleDays: number;
    householdInspectionRequired: boolean;
    csvDownloadTemplate: string;
    eStranacUsername?: string | null;
    eStranacBookSerialNumber?: string | null;
    reloginTime: string;
    showSideMenu: boolean;
    reminderEmail: number;
    localOffsetTime: number;
    countDayStayAsNight: boolean;
    restoreRoomHWDefaultsOnCheckout: boolean;
    hoursBeforeCheckInToChangeRoomMode: number;
    blockConclusionWithActiveTables?: boolean;
}

export interface SubscriptionModel {
    id?: number;
    endpoint?: string;
    p256dh?: string;
    auth?: string;
    subscribedByUser?: string;
    userRole?: string;
    timestamp: number | null;
}
export interface InvoiceQueueModel {
    id?: number;
    payload: string | any;
    status: number; // 1 = pending, 2 = processing, 3= success ,4 = error
    response: string | any;
    timestamp: number;
    invoiceId: number;
    posTerminalId: number | null;
    invoiceNumberFull: string | null;
    processingStartedAt?: number | null;
    fiscalLog?: string | null;
}

export interface NonSequelizeInvoiceModelWithInvoiceItems extends InvoiceModelWithInvoiceItems {
    invoiceItems?: InvoiceItemsModel[];
}
export interface OnlineReceptionReservationModel {
    id?: number;
    receivedAt: number;
    checkInTimestamp: number;
    checkOutTimestamp: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber?: string;
    roomInfoId: number;
    statusEnum?: number; // null-pending, 0-earlyBird, 1-confirmed, 3-canceled
    notes?: string | null;
    adultsNumber: number;
    childrenNumber?: number;
    discountPercentage?: number;
    openPrice?: number | null;
    groupUuid?: string | null;
    verificationToken?: string | null;
    reservationConfirmed?: boolean;
    guestTaxConfig?: GuestTaxConfig | string | null;
    creditCardNumber?: string; // ← Dodano
    creditCardNumberEncKey?: string;
    creditCardExpiry?: string; // ← Dodano (format: MM/YY)
    board: string;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export enum OnlineReceptionReservationStatus {
    earlyBird = 0,
    confirmed = 1,
    canceled = 3,
    pending = 4,
}

export const GLPostingStatusEnum = {
    Disabled: null as null,
    ToBePosted: 1 as 1,
    Posted: 2 as 2,
};

export enum PlanStatus {
    Actual = 'actual',
    Virtual = 'virtual',
}

export interface InitialBalanceModel {
    id?: number;
    date: number;
    description: string | null;
    totalDebit: number;
    totalCredit: number;
    locked: boolean;
    virtualData?: boolean;
    note?: string | null;
    params?: string | null;
    addedByUser?: string;
    User?: UserInfo;
    PosTerminal?: PosTerminalModel;
    posTerminalId: number | null; // zbog frontenda
}

export type DeltaType = 'percentage' | 'fixed';
export type BoardType = 'nb' | 'bb' | 'hb' | 'fb' | 'ai';
export type ChildPricingType = 'free' | 'fixed' | 'percentage';
export type ChildBoardMode = 'inherit' | 'free' | 'custom';
export type ChildBoardValueType = 'fixed' | 'percentage';

export interface ChildBoardPrices {
    nb?: number;
    bb?: number;
    hb?: number;
    fb?: number;
    ai?: number;
}
export interface StaggeredChildRule {
    childOrdinal: number; // 1, 2, 3 (3 = 3.+ dijete)
    pricingType: ChildPricingType;
    fixedValue?: number;
    percentageValue?: number;
}

export interface ChildPriceRule {
    minAge: number;
    maxAge: number; // UKLJUČIVO (<=)

    // Legacy polja (backward compatibility)
    price?: number; // Fiksna cijena (staro)
    priceIndex?: number; // Index u apRules (staro)

    // V2 polja - tip cijene smještaja
    pricingType?: ChildPricingType; // 'free' | 'fixed' | 'percentage'
    fixedValue?: number; // Za 'fixed' tip
    percentageValue?: number; // Za 'percentage' tip (od BASE cijene odraslih)

    // V2 - Staggered pricing (različite cijene za 1., 2., 3.+ dijete)
    useStaggered?: boolean;
    staggeredRules?: StaggeredChildRule[];

    // V2 - Board cijene za djecu
    boardMode?: ChildBoardMode; // 'inherit' | 'free' | 'custom'
    boardValueType?: ChildBoardValueType; // Samo za 'custom' - fiksno ili postotak
    boardPrices?: ChildBoardPrices; // Samo za 'custom'
}

export interface AdultPricingConfig {
    // Kapacitet sobe
    maxOccupancy: number;

    // Included occupancy - koliko osoba uključeno u base cijenu
    includedOccupancy: number;
    basePrice: number;

    // Single use discount - popust za manje osoba
    singleUseEnabled: boolean;
    singleUseType: DeltaType;
    singleUseValue: number;

    // Extra person charge - doplata za više osoba
    extraPersonEnabled: boolean;
    extraPersonType: DeltaType;
    extraPersonValue: number;

    // Fine tuning - ručni override pojedinačnih cijena
    useFinetuning: boolean;
    finetuningOverrides: Record<number, number>; // index → price
}
export interface PriceDetail {
    index: number;
    occupancy: number;
    price: number;
    formulaPrice: number;
    type: 'base' | 'single-use' | 'extra-person';
    isOverride: boolean;
    delta?: number;
    deltaLabel?: string;
}

export interface AdultPricingResult {
    prices: number[];
    priceDetails: PriceDetail[];
}

export interface InferenceResult {
    config: AdultPricingConfig;
    fitScore: number;
    overrides: Record<number, number>;
    generatedPrices: number[];
}

export interface CapResult {
    finalPrice: number;
    capApplied: boolean;
    rawPrice: number;
    capPrice: number;
}

export interface GuestTaxConfigAdult {
    visaInfoId: number | null;
    fixedTaxId: number | null;
    fixedTaxId2: number | null;
    fixedTaxType: 'tax' | 'posItem' | null;
    fixedTaxAmount1?: number | null; // NOVO - snapshot cijene
    fixedTaxAmount2?: number | null; // NOVO - snapshot cijene
    fixedTaxName1?: string | null; // NOVO - snapshot imena
    fixedTaxName2?: string | null; // NOVO - snapshot imena
    checkInTimestamp: number | null;
    checkOutTimestamp: number | null;
    isHolder?: boolean;
}

export interface GuestTaxConfigChild {
    age: number;
    visaInfoId: number | null;
    fixedTaxId: number | null;
    fixedTaxId2: number | null;
    fixedTaxType: 'tax' | 'posItem' | null;
    fixedTaxAmount1?: number | null; // NOVO - snapshot cijene
    fixedTaxAmount2?: number | null; // NOVO - snapshot cijene
    fixedTaxName1?: string | null; // NOVO - snapshot imena
    fixedTaxName2?: string | null; // NOVO - snapshot imena
    checkInTimestamp: number | null;
    checkOutTimestamp: number | null;
}

export interface GuestTaxConfig {
    adults: GuestTaxConfigAdult[];
    children: GuestTaxConfigChild[];
}

export const BOARD_TYPES: BoardType[] = ['nb', 'bb', 'hb', 'fb', 'ai'];

export const BOARD_LABELS: Record<BoardType, string> = {
    nb: 'Samo noćenje',
    bb: 'Doručak',
    hb: 'Polupansion',
    fb: 'Pun pansion',
    ai: 'Sve uključeno',
};

export const BOARD_LABELS_EN: Record<BoardType, string> = {
    nb: 'Room only',
    bb: 'Breakfast',
    hb: 'Half board',
    fb: 'Full board',
    ai: 'All inclusive',
};

export const CHILD_PRICING_TYPE_LABELS: Record<ChildPricingType, string> = {
    free: 'Besplatno',
    fixed: 'Fiksna cijena',
    percentage: 'Postotak',
};

export const CHILD_BOARD_MODE_LABELS: Record<ChildBoardMode, string> = {
    inherit: 'Isto kao odrasli',
    free: 'Besplatno',
    custom: 'Posebne cijene',
};

export const DEFAULT_ADULT_CONFIG: AdultPricingConfig = {
    maxOccupancy: 2,
    includedOccupancy: 2,
    basePrice: 0,
    singleUseEnabled: false,
    singleUseType: 'percentage',
    singleUseValue: 0,
    extraPersonEnabled: false,
    extraPersonType: 'fixed',
    extraPersonValue: 0,
    useFinetuning: false,
    finetuningOverrides: {},
};

export const DEFAULT_CHILD_RULE: ChildPriceRule = {
    minAge: 0,
    maxAge: 6,
    pricingType: 'free',
    useStaggered: false,
    staggeredRules: [],
    boardMode: 'inherit',
};

export const DEFAULT_STAGGERED_RULES: StaggeredChildRule[] = [
    { childOrdinal: 1, pricingType: 'free' },
    { childOrdinal: 2, pricingType: 'percentage', percentageValue: 50 },
    { childOrdinal: 3, pricingType: 'percentage', percentageValue: 75 },
];


export interface CisuGuestRegistrationModel {
    id?: number;
    reservationGuestReferenceId: number | null;
    reservationId: number;
    entryNumber: number | null;
    entryYear: number | null;
    cisuGuestId: number | null;
    cisuStatus: number;
    cisuLastError: string | null;
    cisuRegisteredAt: number | null;
    cisuCheckedOutAt: number | null;
    guestTypeCode: string;
    name: string | null;
    genderCode: string | null;
    dateOfBirth: string | null;
    birthCountryCode: string | null;
    birthPlace: string | null;
    checkInDate: string | null;
    plannedCheckOutDate: string | null;
    travelPurposeCode: string | null;
    arrivalTypeCode: string | null;
    accommodationServiceTypeCode: string | null;
    unitNumber: string | null;
    unitFloor: string | null;
    address: string | null;
    residenceTaxReductionCode: string | null;
    travelAgencyIdentifier: string | null;
    foreignTravelAgencyName: string | null;
    foreignTravelAgencyCountryCode: string | null;
    guestAccommodationUnitList: string | null;
    identifier: string | null;
    birthMunicipality: string | null;
    residenceMunicipalityCode: string | null;
    residencePlaceCode: string | null;
    citizenshipCountryCode: string | null;
    identityCardTypeCode: string | null;
    identityCardNumber: string | null;
    identityCardExpiryDate: string | null;
    identityCardIssuer: string | null;
    visaTypeCode: string | null;
    visaNumber: string | null;
    visaExpiryDate: string | null;
    visaIssuancePlace: string | null;
    entryDate: string | null;
    entryPlace: string | null;
    residencePermitExpiryDate: string | null;
    billNumber: string | null;
    numberOfServices: number | null;
    checkOutNote: string | null;
    hasPendingChanges: boolean;
    isDeleted: boolean;
}

export enum ResidenceTaxReductionCodeCISU {
    childrenUnder12 = 1,
    spaClimateTreatmentReferral = 2,
    spaClimateTreatmentIndividual = 3,
    personsWithDisabilities = 4,
    childrenWithDevelopmentalDisabilitiesForeignCare = 5,
    adultsWithDisabilitiesForeignCare = 6,
    studentsOrganizedStay = 7,
    studentsSchooling = 8,
    foreignNationalsTaxExempt = 9,
    youth12To18 = 10,
    stayLongerThan30Days = 11,
}

